import API from './commons/Api.js';
import router from './commons/Router.js';
import {eventBus, EVENTS} from './commons/EventBus.js';
import Utils from './commons/utils.js';
import {Paginator} from "./commons/paginator.js";

let downloadTimer = false;
let maxPartecipazioni = 0;
let onPartecipa = () => {
};
eventBus.on(EVENTS.PAGE_AFTER_RENDERING, function (data) {

  const template = data.template;

  if (template != 'giochi' && template != 'dettaglio_gioco') {
    return;
  }

  if (template == 'giochi') {

    // giochi online
    const breakpoints_giochi_online = [
      {maxWidth: 550, perPage: 1},
      {maxWidth: 850, perPage: 2},
      {perPage: 3}
    ];

    new Paginator($('.pagination_blocco_giochi_online'), {
      total: $(".contest-single-box").length,
      breakpoints: breakpoints_giochi_online,
      cssVar: '--go_paginator',
      swipeElementSelector: '#giochi-giochi-attivi'
    });

    // giochi in radio
    const breakpoints_giochi_in_radio = [
      {maxWidth: 550, perPage: 1},
      {perPage: 2}
    ];

    new Paginator($('.pagination_blocco_giochi_in_radio'), {
      total: 6,
      breakpoints: breakpoints_giochi_in_radio,
      cssVar: '--gir_paginator',
      swipeElementSelector: '#giochi-giochi-in-radio'
    });
  } else if (template == 'dettaglio_gioco') {

    // giochi online dettaglio
    const breakpoints_giochi_online_dettaglio = [
      {maxWidth: 550, perPage: 1},
      {maxWidth: 850, perPage: 2},
      {perPage: 3}
    ];

    new Paginator($('.pagination_blocco_giochi_online_dettaglio'), {
      total: $(".contest-single-box").length,
      breakpoints: breakpoints_giochi_online_dettaglio,
      cssVar: '--ggr_paginator',
      swipeElementSelector: '#dettaglio_gioco-giochi-attivi'
    });
  }


});

eventBus.on(EVENTS.PAGE_AFTER_RENDERING, function (data) {
  console.log('after render data',data)
  const template = data.template;

  if (template != 'dettaglio_gioco') {
    return;
  }

  // data = recallGiochi(location.pathname.split('/')[2]);

  if (data._formServer){
    $('#cta_gioco').hide();
    checkPageReal();
    return;
  }

  checkGioco(data);

  $('#toggle_select_gioco_order').off('click').on('click', (e) => {
    $(".option_select_container_giochi").slideToggle();
    $("#toggle_select_gioco_order").find(".icon_dropdown").toggleClass("open");
  });

});

// function recallGiochi(url) {
//   return new Promise((resolve, reject)=>{
//     API.get('/site/giochi/'+url, {}, function (data) {
//       if (data.status != 1){
//         reject();
//         return;
//       }
//       resolve(data);
//     });
//   });
// }

function checkGioco(data) {
  if (data.refresh) {
    return;
  }

  //CONTROLLO SE IL GIOCO E' DEPOSITATO AL MINISTERO (CUSTOM)
  if (data.content.gioco_depositato_custom == 1) {
    window.gioco_depositato_custom = true;
    window.html_gioco_depositato_custom = data.content.html_gioco_depositato_custom;
    window.accettazione_privacy_custom = data.content.accettazione_privacy_custom;
    window.accettazione_gioco_depositato_custom = false;
  } else {
    window.gioco_depositato_custom = false;
    window.html_gioco_depositato_custom = "";
    window.accettazione_privacy_custom = "0";
    window.accettazione_gioco_depositato_custom = true;
  }

  window.tipologia_gioco = data.content.tipologia;
  if (window.tipologia_gioco === "gioco_codice"){
    window.maggiorenne = data.content.maggiorenne;
    window.passaporto = data.content.passaporto;
    window.template_gioco = data.content.template_gioco;
    window.titolo_popup = data.content.titolo_popup;
    window.testo_popup = data.content.testo_popup;
  }
  window.gioco_id = data.content.post_id;
  window.slug_game = data.metadata.url;
  window.percentuale_di_vincita = data.content.percentuale_di_vincita;
  onPartecipa = () => {
  };

  if (!data.subtemplates['giochi-attivi'].length) {
    $('.container-giochi-on-line').hide()
  }
  Utils.showWaitingLoader();

  // mostro o nascondo il container dei partecipanti per ugc e vota item
  if (data.content.tipologia == "ugc" || data.content.tipologia == "vota_item") {

    $('popup-gioco-carica-file-ugc').show();

    if (data.content.tipologia == "ugc") {
      window.tipo_contenuto_ugc = data.content.tipo_contenuto;
      window.liberatoria_obbligatoria_ugc = data.content.liberatoria_obbligatoria;
    }

  } else {
    $("#gioco-container-items-gioco").remove();
  }

  if (data.content.tipologia == "true_view") {
    window.url_video_hls_trueview = data.content.url_video_hls_trueview;
    window.scelta_trueview = "";
  } else {
    $("#gioco-trueview-quesito").remove();
  }

  if (data.content.tipologia == "music_engine" || data.content.tipologia == "quiz" || data.content.tipologia == "gioco_select") {
    //TODO:
  } else {
    $("#gioco-music-engine-quesiti-container").remove();
    $("#gioco-music-engine-il-tuo-profilo").remove();
  }

  if (data.content.tipologia != "instant_win") {
    $("#gioco_instant_win").remove();
  }
  if (data.is_user) {
    console.log("yes")
  } else {
    console.log("no")
  }
  // user.checkUser(function(utente){

  if (!data.check && data.content.status_gioco == 'CONCLUSO') {
    esegui_azioni_gioco_concluso();
    return;
  }

  if (data.content.status_gioco == 'FUTURO') {
    $(".cta-button").hide();
    return;
  }

  if (data.is_user) {

    console.log("check", data.check);
    // API.post("community/checkGiocata", {post_id: data.content.post_id}, function (resp) {
    //CONTROLLO SE IL GIOCO E' CONCLUSO
    if (!data.check && data.content.status_gioco == 'CONCLUSO') {
      esegui_azioni_gioco_concluso();
      return;
    }


    var resp = data.content;
    Utils.hideWaitingLoader();
    console.log("DATA", data);
    const tipologia_gioco = data.content.tipologia;
    if (tipologia_gioco == "gioco_semplice") {

      if (data.check == 1) {
        hai_gia_partecipato("gioco_semplice", {punti: data.punti});
      }

    } else if (tipologia_gioco == "gioco_select") {
      $('.container-giochi-on-line').hide();
      if (data.check == 1) {
        hai_gia_partecipato("gioco_select", {punti: data.punti});
      } else {
        popolaGiocoQuiz(data, data.content.tipologia);
      }

    } else if (tipologia_gioco == "true_view") {

      if (data.check == 1) {
        hai_gia_partecipato("true_view", {punti: data.punti});
      }

    } else if (tipologia_gioco == "ugc") {

      if (data.check == 1) {

        hai_gia_partecipato("ugc", {
          punti: data.punti,
          ugc_nome: data.ugc_nome,
          ugc_percentuale_voti: data.ugc_percentuale_voti,
          ugc_immagine: data.ugc_immagine
        });
      } else {
        $('#rds-form-gioco-ugc').show();
        //ugc
      }

    } else if (tipologia_gioco == "vota_item") {

      if (data.check == 1) {
        hai_gia_partecipato("vota_item", {punti: resp.punti});
      }

    } else if (tipologia_gioco == "music_engine") {

      // SE NON HO ANCORA GIOCATO POPOLO IL GIOCO
      if (data.check == 0) {


      } else if (data.check == 1) {

        hai_gia_partecipato(data.content.tipologia, {
          punti: data.punti,
          music_engine_profilo: data.music_engine_profilo,
          music_engine_descrizione: data.music_engine_descrizione,
          music_engine_canzone: data.music_engine_canzone,
          music_engine_immagine: data.music_engine_immagine
        });

      }

    } else if (tipologia_gioco == "quiz") {

      // SE NON HO ANCORA GIOCATO POPOLO IL GIOCO
      if (data.check == 0) {

        popolaGiocoQuiz(data);

      } else if (data.check == 1) {

        hai_gia_partecipato(data.content.tipologia, {
          punti: data.punti,
          music_engine_profilo: data.music_engine_profilo,
          music_engine_descrizione: data.music_engine_descrizione,
          music_engine_canzone: data.music_engine_canzone,
          music_engine_immagine: data.music_engine_immagine
        });

      }

    } else if(tipologia_gioco == "gioco_codice"){
      if (data.check == 1){
        hai_gia_partecipato(data.content.tipologia,{punti: data.punti})
      }
    }

    // }, function () {
    //     Utils.hideWaitingLoader();
    // });

    // }, function (){
  } else {
    Utils.hideWaitingLoader();

    if (data.content.tipologia == "ugc") {

      if (data.content.tipo_contenuto == "FOTO") {
        $('#dettaglio-gioco-ugc-file').attr("accept", "image/x-png,image/jpeg");
      } else {
        $('#dettaglio-gioco-ugc-file').attr("accept", "video/mp4,video/x-m4v,video/*");
      }

      // controllo se la liberatoria è obbligatoria o meno

      if (data.content.liberatoria_obbligatoria == 1) {
        $('#dettaglio-ugc-box-liberatoria').css('display', 'inline-block');
      } else {
        $('#dettaglio-ugc-box-liberatoria').css('display', 'none');
      }

    } else if (data.content.tipologia == "music_engine") {

      popolaGiocoMusicEngine(data);

    } else if (data.content.tipologia == "quiz") {
      popolaGiocoQuiz(data, data.content.tipologia);
    } else if (data.content.tipologia == "gioco_select") {
      popolaGiocoQuiz(data, data.content.tipologia);

    }


  }
  // });

}

function esegui_azioni_gioco_concluso() {
  console.log("GIOCO CONCLUSO");
  $("#gioco-container-cta").hide();
  $(".come-partecipare").hide();
  $("#gioco-container-gioco-concluso").fadeIn();
}

function hai_gia_partecipato(type, param, message, dataCheck=1) {
  if(!dataCheck){
    eventBus.emit(EVENTS.GIOCO_SEMPLICE_END, {url: location.href});
  }
  let img_warn = $(".img-warning")[0];
  let popup_conferma =$(".popup-conferma-button")[0];

  if (img_warn.style.display == 'none'){
    img_warn.style.display = 'block';
  }
  if (popup_conferma.style.display == 'none'){
    popup_conferma.style.display = 'flex';
  }

  if (type == "gioco_semplice" || type == "gioco_codice") {
    if(!message){
      message="GRAZIE PER AVER PARTECIPATO AL CONCORSO!";
    }
    $('#popup-messaggio-box .x-delete').hide();
    Utils.alertMessage(message, function () {
      $("#gioco-container-cta").fadeOut();
      $("#gioco-container-hai-gia-giocato .points").html("Hai ottenuto " + param.punti + " punti.");
      $("#gioco-container-hai-gia-giocato").fadeIn();
      // $(".come-partecipare").fadeOut();   //Chiesto di far mostrare anche dopo aver giocato
      $('#popup-messaggio-box .x-delete').show();
    });

  } else if (type == 'gioco_select') {
    $("#gioco-music-engine-quesiti-container").fadeOut();
    $('html, body, .main-page').animate({
      scrollTop: 0
    }, 500);
    $("#gioco-container-cta").fadeOut();
    $("#gioco-container-hai-gia-giocato").fadeIn();
    //$(".come-partecipare").fadeOut(); //Chiesto di far mostrare anche dopo aver giocato
  } else if (type == "ugc") {

    $("#gioco-container-cta").fadeOut();
    $("#gioco-container-hai-gia-giocato .points").html("Hai già votato ottenendo " + param.punti + " punti.");
    $("#gioco-container-hai-gia-giocato").fadeIn();
   // $(".come-partecipare").fadeOut();  //Chiesto di far mostrare anche dopo aver giocato

    if (param.ugc_nome && param.ugc_immagine) {

      $("#gioco-i-miei-dati-nome").html(param.ugc_nome);

      if (param.ugc_percentuale_voti == "0") {
        $("#gioco-i-miei-dati-punti").html("Hai ottenuto lo " + param.ugc_percentuale_voti + "% di voti");
      } else if (param.ugc_percentuale_voti == "1") {
        $("#gioco-i-miei-dati-punti").html("Hai ottenuto l' " + param.ugc_percentuale_voti + "% di voti");
      } else {
        $("#gioco-i-miei-dati-punti").html("Hai ottenuto il " + param.ugc_percentuale_voti + "% di voti");
      }

      $("#gioco-i-miei-dati-immagine").attr("src", param.ugc_immagine);

      $("#gioco-i-miei-dati-container").show();

    }

  } else if (type == "vota_item") {

    $("#gioco-container-cta").fadeOut();
    $("#gioco-container-hai-gia-giocato .points").html("Hai già votato ottenendo " + param.punti + " punti.");
    $("#gioco-container-hai-gia-giocato").fadeIn();
    //$(".come-partecipare").fadeOut();   //Chiesto di far mostrare anche dopo aver giocato

  } else if (type == "true_view") {

    $("#close_bottom_player").trigger("click");

    $("#gioco-container-cta").fadeOut();
    $("#gioco-container-hai-gia-giocato .points").html("Hai ottenuto " + param.punti + " punti.");
    $("#gioco-container-hai-gia-giocato").fadeIn();
   // $(".come-partecipare").fadeOut();      //Chiesto di far mostrare anche dopo aver giocato

  } else if (type == "music_engine" || type == "quiz") {
    $("#gioco-container-cta").fadeOut();
    $("#gioco-container-hai-gia-giocato .points").html("Hai ottenuto " + param.punti + " punti.");
    $("#gioco-container-hai-gia-giocato").fadeIn();
    //$(".come-partecipare").fadeOut();   //Chiesto di far mostrare anche dopo aver giocato
    if (param.music_engine_profilo && param.music_engine_descrizione && param.music_engine_canzone && param.music_engine_immagine) {
      $("#gioco-music-engine-il-tuo-profilo").fadeIn();
      $("#gioco-music-engine-profilo").html(param.music_engine_profilo);
      $("#gioco-music-engine-descrizione").html(param.music_engine_descrizione);
      $("#gioco-music-engine-canzone").html("Canzone associata: " + param.music_engine_canzone);
      $("#gioco-music-engine-immagine").attr("src", param.music_engine_immagine);
    }
  }

  if (type != "music_engine") {
    $("html").animate({scrollTop: 0}, 500);
  }
}

function popolaOptionGiocoSelect(data) {
  var str_risposte = data.content.risposte_select;
  var risposte = str_risposte.split("|");
  for (var i = 0; i < risposte.length; i++) {
    $("#rds-select-gioco-select").append("<option value='" + risposte[i] + "'>" + risposte[i] + "</option>");
  }
}

function popolaGiocoQuiz(data, tipologia) {
  json_risposte(data, tipologia);
  $("#rds-domande-gioco-quiz-posizione").val(0);
}

function popolaGiocoMusicEngine(data) {

  var struttura_domande = "";

  for (var j = 0; j < data.content.num_domande; j++) {

    var json_risposte = JSON.parse(data.content.gioco_quiz[j].json_risposte);
    var ans = "";
    for (var k = 0; k < 3; k++) {
      ans += "<div class='contenitore_risposta_gioco_quiz' data-id='" + json_risposte[k].profile + "' onclick='rispondiGiocoMusicEngine(this," + data.content.post_id + "," + data.content.gioco_quiz[j].domanda_id + "," + json_risposte[k].id + "," + j + ")' ><p id='id-risposta-" + json_risposte[k].id + "' class='content-gioco-punti-gioco-quiz'>" + json_risposte[k].risposta + "</p></div>";
    }

    struttura_domande += "<div id='singola_domanda_" + j + "_gioco_quiz' class='singola_domanda_gioco_quiz singola_domanda_" + data.content.gioco_quiz[j].domanda_id + "_gioco_quiz' ><p class='content-gioco-played-trueview'>" + data.content.gioco_quiz[j].domanda + "</p><div style='text-align:center;'>" + ans + "</div></div>";

  }

  $("#rds-domande-gioco-quiz").html(struttura_domande);

  $("#singola_domanda_0_gioco_quiz").show();

  $("#rds-domande-gioco-quiz-posizione").val(0);

}

function checkGiocoVotaItem(data) {
  if (data.content.tipo_vota_item == "VIDEO") {
    console.log("VOTA ITEM: VIDEO");
  } else {
    console.log("VOTA ITEM: FOTO");
  }
}

/**************************** GIOCO SEMPLICE **********************************/
function partecipaGiocoSemplice(post_id) {

  // controllo l'eventuale assenza di campi obbligatori
  var utente = USER.getLocalUser();

  if (checkPopupMandatoryFields(utente, partecipaGiocoSemplice, [post_id])) {
    return;
  }

  // sezione relativa alle spunte privacy e regolamento
  if (!window.accettazione_gioco_depositato) {
    // se l'utente non risulta loggato
    if (!USER.getLocalUser()) {
      $("img#rds-header-users-icon").trigger('click');
      return;
    }
    if (isSmartphone()) {
      $(".rds-modal-popup-box").css("width", "100%");
      $(".rds-modal-popup-box").css("height", "100%");
      $(".rds-modal-popup-box").css("margin-top", "140px");
    } else {
      $(".rds-modal-popup-box").css("width", "335px");
      $(".rds-modal-popup-box").css("height", "auto");
    }
    window.clickOkGiocoDepositato = function () {
      var check_regolamento = $('input[name=checkbox-regolamento-gioco-depositato]:checked').val() == 1 ? 1 : 0;
      var check_privacy = $('input[name=checkbox-liberatoria-gioco-depositato]:checked').val() == 1 ? 1 : 0;
      if (check_regolamento == 1 && check_privacy == 1) {
        RDSMODALPOPUP.close();
        window.accettazione_gioco_depositato = true;
        partecipaGiocoSemplice(post_id);
      } else {
        alertError("Leggi e accetta entrambi i documenti per proseguire!");
      }
    };
    $("#rds-popup-content").html(window.templates["confirm-gioco-depositato"]);

    $("#anchor-regolamento").prop("href", window.url_regolamento);
    $("#anchor-liberatoria").prop("href", window.url_liberatoria);

    RDSMODALPOPUP.open();
    return;
  }

  // G.A @ 29/07/2019 - sezione relativa alle spunte privacy e regolamento (gioco depositato al ministero custom)
  if (!window.accettazione_gioco_depositato_custom) {
    // se l'utente non risulta loggato
    if (!USER.getLocalUser()) {
      $("img#rds-header-users-icon").trigger('click');
      return;
    }
    if (isSmartphone()) {
      $(".rds-modal-popup-box").css("width", "100%");
      $(".rds-modal-popup-box").css("height", "100%");
      $(".rds-modal-popup-box").css("margin-top", "140px");
    } else {
      $(".rds-modal-popup-box").css("width", "335px");
      $(".rds-modal-popup-box").css("height", "auto");
    }
    window.clickOkGiocoDepositatoCustom = function () {
      var check_regolamento = $('input[name=checkbox-regolamento-gioco-depositato-custom]:checked').val() == 1 ? 1 : 0;

      if (accettazione_privacy_custom == "0") {
        var check_privacy = 1;
      } else {
        var check_privacy = $('input[name=checkbox-liberatoria-gioco-depositato-custom]:checked').val() == 1 ? 1 : 0;
      }

      if (check_regolamento == 1 && check_privacy == 1) {
        RDSMODALPOPUP.close();
        window.accettazione_gioco_depositato_custom = true;
        partecipaGiocoSemplice(post_id);
      } else {
        alertError("Leggi e accetta i campi obbligatori prima di proseguire!");
      }
    };
    $("#rds-popup-content").html(window.templates["confirm-gioco-depositato-custom"]);
    $("#html_gioco_depositato_custom").html(window.html_gioco_depositato_custom);
    RDSMODALPOPUP.open();
    return;
  }

  // continuo col il partecipa
  showWaitingLoader();
  API.post("community/partecipaGioco/" + post_id, {post_id: post_id}, function (resp) {
    hideWaitingLoader();
    if (resp.status == 0) {
      $('.content-gioco-partecipa').show();
      $('.main-page').animate({
        scrollTop: jQuery(".content-gioco-partecipa-dettaglio").offset().top
      }, 500);
      $('.gioco-partecipa-open').hide();
      $('.featured-image-gioco-partecipa').hide();
      USER.saveLocalUser(resp.user);
      USER.showProfileWidget();
    } else if (resp.status == 1) {
      alertError("Hai già giocato!");
    } else if (resp.status == -1) {
      $("img#rds-header-users-icon").trigger('click');
    } else if (resp.status == -3) {
      alertError(resp.message);
    }
  }, function () {
    hideWaitingLoader();
    alertError("Si e' verificato un errore, prova a giocate piu' tardi");
  });
}

function chiudiGiocoSemplice() {
  $('.gioco-partecipa-open').show();
  $('.featured-image-gioco-partecipa').show();
  $('.content-gioco-partecipa').hide();
  $('.main-page').animate({
    scrollTop: jQuery("#rds-section-main").offset().top
  }, 500);
}

/**************************** GIOCO TRUEVIEW **********************************/

function partecipaTrueview() {

  // controllo l'eventuale assenza di campi obbligatori
  var utente = USER.getLocalUser();

  if (checkPopupMandatoryFields(utente, partecipaTrueview, [])) {
    return;
  }

  // sezione relativa alle spunte privacy e regolamento
  if (!window.accettazione_gioco_depositato) {
    // se l'utente non risulta loggato
    if (!USER.getLocalUser()) {
      $("img#rds-header-users-icon").trigger('click');
      return;
    }
    if (isSmartphone()) {
      $(".rds-modal-popup-box").css("width", "100%");
      $(".rds-modal-popup-box").css("height", "100%");
      $(".rds-modal-popup-box").css("margin-top", "140px");
    } else {
      $(".rds-modal-popup-box").css("width", "335px");
      $(".rds-modal-popup-box").css("height", "auto");
    }
    window.clickOkGiocoDepositato = function () {
      var check_regolamento = $('input[name=checkbox-regolamento-gioco-depositato]:checked').val() == 1 ? 1 : 0;
      var check_privacy = $('input[name=checkbox-liberatoria-gioco-depositato]:checked').val() == 1 ? 1 : 0;
      if (check_regolamento == 1 && check_privacy == 1) {
        RDSMODALPOPUP.close();
        window.accettazione_gioco_depositato = true;
        partecipaTrueview();
      } else {
        alertError("Leggi e accetta entrambi i documenti per proseguire!");
      }
    };
    $("#rds-popup-content").html(window.templates["confirm-gioco-depositato"]);

    $("#anchor-regolamento").prop("href", window.url_regolamento);
    $("#anchor-liberatoria").prop("href", window.url_liberatoria);

    RDSMODALPOPUP.open();
    return;
  }

  // G.A @ 29/07/2019 - sezione relativa alle spunte privacy e regolamento (gioco depositato al ministero custom)
  if (!window.accettazione_gioco_depositato_custom) {
    // se l'utente non risulta loggato
    if (!USER.getLocalUser()) {
      $("img#rds-header-users-icon").trigger('click');
      return;
    }
    if (isSmartphone()) {
      $(".rds-modal-popup-box").css("width", "100%");
      $(".rds-modal-popup-box").css("height", "100%");
      $(".rds-modal-popup-box").css("margin-top", "140px");
    } else {
      $(".rds-modal-popup-box").css("width", "335px");
      $(".rds-modal-popup-box").css("height", "auto");
    }
    window.clickOkGiocoDepositatoCustom = function () {
      var check_regolamento = $('input[name=checkbox-regolamento-gioco-depositato-custom]:checked').val() == 1 ? 1 : 0;

      if (accettazione_privacy_custom == "0") {
        var check_privacy = 1;
      } else {
        var check_privacy = $('input[name=checkbox-liberatoria-gioco-depositato-custom]:checked').val() == 1 ? 1 : 0;
      }

      if (check_regolamento == 1 && check_privacy == 1) {
        RDSMODALPOPUP.close();
        window.accettazione_gioco_depositato_custom = true;
        partecipaTrueview();
      } else {
        alertError("Leggi e accetta i campi obbligatori prima di proseguire!");
      }
    };
    $("#rds-popup-content").html(window.templates["confirm-gioco-depositato-custom"]);
    $("#html_gioco_depositato_custom").html(window.html_gioco_depositato_custom);
    RDSMODALPOPUP.open();
    return;
  }

  // continuo col il partecipa
  showWaitingLoader();
  USER.checkUser(function (user) {
    hideWaitingLoader();
    $('.content-gioco-partecipa').show();
    $('.main-page').animate({
      scrollTop: jQuery(".content-gioco-partecipa-dettaglio").offset().top
    }, 500);
    $('.gioco-partecipa-open').hide();
    $('.featured-image-gioco-partecipa').hide();
    $('.featured-image-gioco-partecipa-close').hide();
  }, function () {
    hideWaitingLoader();
    $("img#rds-header-users-icon").trigger('click');
  });

}

function chiudiTrueview() {
  $('.gioco-partecipa-open').show();
  $('.featured-image-gioco-partecipa').show();
  $('.content-gioco-partecipa').hide();
  $('.main-page').animate({
    scrollTop: jQuery("#rds-section-main").offset().top
  }, 500);
}

function avantiTrueView(post_id) {

  var selezioneTrueView = $("input[name='risposta_trueview']:checked").val();
  var rispostaCorretta = $("#rds-re-true-view").val();

  if (selezioneTrueView == undefined) {
    alertError("Devi selezionare una risposta prima di andare avanti!");
    return;
  }

  if (rispostaCorretta !== selezioneTrueView) {
    alertError("Risposta errata!");
    return;
  }

  showWaitingLoader();

  API.post("community/partecipaGioco/" + post_id, {post_id: post_id}, function (resp) {
    hideWaitingLoader();
    if (resp.status == 0) {
      $('.box-container-trueview').hide();
      $('.box-container-riepilogo').show();
      $('.main-page').animate({
        scrollTop: jQuery("#rds-section-main").offset().top
      }, 500);
      USER.saveLocalUser(resp.user);
      USER.showProfileWidget();
    } else if (resp.status == 1) {
      alertError("Hai già giocato!");
    } else if (resp.status == -1) {
      $("img#rds-header-users-icon").trigger('click');
    } else if (resp.status == -3) {
      alertError(resp.message);
    }
  }, function () {
    hideWaitingLoader();
    alertError("Si e' verificato un errore, prova a giocate piu' tardi");
  });

}

/**************************** GIOCO SELECT ************************************/

function partecipaSelect() {

  // controllo l'eventuale assenza di campi obbligatori
  var utente = USER.getLocalUser();

  if (checkPopupMandatoryFields(utente, partecipaSelect, [])) {
    return;
  }

  // sezione relativa alle spunte privacy e regolamento
  if (!window.accettazione_gioco_depositato) {
    // se l'utente non risulta loggato
    if (!USER.getLocalUser()) {
      $("img#rds-header-users-icon").trigger('click');
      return;
    }
    if (isSmartphone()) {
      $(".rds-modal-popup-box").css("width", "100%");
      $(".rds-modal-popup-box").css("height", "100%");
      $(".rds-modal-popup-box").css("margin-top", "140px");
    } else {
      $(".rds-modal-popup-box").css("width", "335px");
      $(".rds-modal-popup-box").css("height", "auto");
    }
    window.clickOkGiocoDepositato = function () {
      var check_regolamento = $('input[name=checkbox-regolamento-gioco-depositato]:checked').val() == 1 ? 1 : 0;
      var check_privacy = $('input[name=checkbox-liberatoria-gioco-depositato]:checked').val() == 1 ? 1 : 0;
      if (check_regolamento == 1 && check_privacy == 1) {
        RDSMODALPOPUP.close();
        window.accettazione_gioco_depositato = true;
        partecipaSelect();
      } else {
        alertError("Leggi e accetta entrambi i documenti per proseguire!");
      }
    };
    $("#rds-popup-content").html(window.templates["confirm-gioco-depositato"]);

    $("#anchor-regolamento").prop("href", window.url_regolamento);
    $("#anchor-liberatoria").prop("href", window.url_liberatoria);

    RDSMODALPOPUP.open();
    return;
  }

  // G.A @ 29/07/2019 - sezione relativa alle spunte privacy e regolamento (gioco depositato al ministero custom)
  if (!window.accettazione_gioco_depositato_custom) {
    // se l'utente non risulta loggato
    if (!USER.getLocalUser()) {
      $("img#rds-header-users-icon").trigger('click');
      return;
    }
    if (isSmartphone()) {
      $(".rds-modal-popup-box").css("width", "100%");
      $(".rds-modal-popup-box").css("height", "100%");
      $(".rds-modal-popup-box").css("margin-top", "140px");
    } else {
      $(".rds-modal-popup-box").css("width", "335px");
      $(".rds-modal-popup-box").css("height", "auto");
    }
    window.clickOkGiocoDepositatoCustom = function () {
      var check_regolamento = $('input[name=checkbox-regolamento-gioco-depositato-custom]:checked').val() == 1 ? 1 : 0;

      if (accettazione_privacy_custom == "0") {
        var check_privacy = 1;
      } else {
        var check_privacy = $('input[name=checkbox-liberatoria-gioco-depositato-custom]:checked').val() == 1 ? 1 : 0;
      }

      if (check_regolamento == 1 && check_privacy == 1) {
        RDSMODALPOPUP.close();
        window.accettazione_gioco_depositato_custom = true;
        partecipaSelect();
      } else {
        alertError("Leggi e accetta i campi obbligatori prima di proseguire!");
      }
    };
    $("#rds-popup-content").html(window.templates["confirm-gioco-depositato-custom"]);
    $("#html_gioco_depositato_custom").html(window.html_gioco_depositato_custom);
    RDSMODALPOPUP.open();
    return;
  }

  // continuo col il partecipa
  showWaitingLoader();
  USER.checkUser(function (user) {
    hideWaitingLoader();
    $('.content-gioco-partecipa').show();
    $('.main-page').animate({
      scrollTop: jQuery(".content-gioco-partecipa-dettaglio").offset().top
    }, 500);
    $('.gioco-partecipa-open').hide();
    $('.featured-image-gioco-partecipa').hide();
  }, function () {
    hideWaitingLoader();
    $("img#rds-header-users-icon").trigger('click');
  });
}

function chiudiSelect() {
  $('.gioco-partecipa-open').show();
  $('.featured-image-gioco-partecipa').show();
  $('.content-gioco-partecipa').hide();
  $('.main-page').animate({
    scrollTop: jQuery("#rds-section-main").offset().top
  }, 500);
}

function avantiGiocoSelect(post_id) {

  var selezioneSelect = $("#rds-select-gioco-select").val();

  if (selezioneSelect == "-") {
    alertError("Devi selezionare una scelta prima di andare avanti!");
    return;
  }
  showWaitingLoader();

  API.post("community/partecipaGioco/" + post_id, {post_id: post_id, risposta: selezioneSelect}, function (resp) {
    hideWaitingLoader();
    if (resp.status == 0) {
      $('.box-container-select').hide();
      $('.box-container-riepilogo').show();
      $('.main-page').animate({
        scrollTop: jQuery("#rds-section-main").offset().top
      }, 500);
      USER.saveLocalUser(resp.user);
      USER.showProfileWidget();
    } else if (resp.status == 1) {
      alertError("Hai già giocato!");
    } else if (resp.status == -1) {
      $("img#rds-header-users-icon").trigger('click');
    } else if (resp.status == 10) {
      alertError(resp.message);
    } else if (resp.status == -3) {
      alertError(resp.message);
    }
  }, function () {
    hideWaitingLoader();
    alertError("Si e' verificato un errore, prova a giocate piu' tardi");
  });

}

/******************************* GIOCO QUIZ ************************************/

function mostraDomandeGiocoQuiz() {
  $("#rds-trueview-container").show();
};

function partecipaGiocoQuiz(post_id, durata_gioco) {

  // controllo l'eventuale assenza di campi obbligatori
  var utente = USER.getLocalUser();

  if (checkPopupMandatoryFields(utente, partecipaGiocoQuiz, [post_id, durata_gioco])) {
    return;
  }

  // sezione relativa alle spunte privacy e regolamento
  if (!window.accettazione_gioco_depositato) {
    // se l'utente non risulta loggato
    if (!USER.getLocalUser()) {
      $("img#rds-header-users-icon").trigger('click');
      return;
    }
    if (isSmartphone()) {
      $(".rds-modal-popup-box").css("width", "100%");
      $(".rds-modal-popup-box").css("height", "100%");
      $(".rds-modal-popup-box").css("margin-top", "140px");
    } else {
      $(".rds-modal-popup-box").css("width", "335px");
      $(".rds-modal-popup-box").css("height", "auto");
    }
    window.clickOkGiocoDepositato = function () {
      var check_regolamento = $('input[name=checkbox-regolamento-gioco-depositato]:checked').val() == 1 ? 1 : 0;
      var check_privacy = $('input[name=checkbox-liberatoria-gioco-depositato]:checked').val() == 1 ? 1 : 0;
      if (check_regolamento == 1 && check_privacy == 1) {
        RDSMODALPOPUP.close();
        window.accettazione_gioco_depositato = true;
        partecipaGiocoQuiz(post_id, durata_gioco);
      } else {
        alertError("Leggi e accetta entrambi i documenti per proseguire!");
      }
    };
    $("#rds-popup-content").html(window.templates["confirm-gioco-depositato"]);

    $("#anchor-regolamento").prop("href", window.url_regolamento);
    $("#anchor-liberatoria").prop("href", window.url_liberatoria);

    RDSMODALPOPUP.open();
    return;
  }

  // G.A @ 29/07/2019 - sezione relativa alle spunte privacy e regolamento (gioco depositato al ministero custom)
  if (!window.accettazione_gioco_depositato_custom) {
    // se l'utente non risulta loggato
    if (!USER.getLocalUser()) {
      $("img#rds-header-users-icon").trigger('click');
      return;
    }
    if (isSmartphone()) {
      $(".rds-modal-popup-box").css("width", "100%");
      $(".rds-modal-popup-box").css("height", "100%");
      $(".rds-modal-popup-box").css("margin-top", "140px");
    } else {
      $(".rds-modal-popup-box").css("width", "335px");
      $(".rds-modal-popup-box").css("height", "auto");
    }
    window.clickOkGiocoDepositatoCustom = function () {
      var check_regolamento = $('input[name=checkbox-regolamento-gioco-depositato-custom]:checked').val() == 1 ? 1 : 0;

      if (accettazione_privacy_custom == "0") {
        var check_privacy = 1;
      } else {
        var check_privacy = $('input[name=checkbox-liberatoria-gioco-depositato-custom]:checked').val() == 1 ? 1 : 0;
      }

      if (check_regolamento == 1 && check_privacy == 1) {
        RDSMODALPOPUP.close();
        window.accettazione_gioco_depositato_custom = true;
        partecipaGiocoQuiz(post_id, durata_gioco);
      } else {
        alertError("Leggi e accetta i campi obbligatori prima di proseguire!");
      }
    };
    $("#rds-popup-content").html(window.templates["confirm-gioco-depositato-custom"]);
    $("#html_gioco_depositato_custom").html(window.html_gioco_depositato_custom);
    RDSMODALPOPUP.open();
    return;
  }

  // continuo col il partecipa
  showWaitingLoader();
  API.post("community/partecipaGioco/" + post_id, {post_id: post_id}, function (resp) {
    hideWaitingLoader();
    if (resp.status == 0) {

      $('.content-gioco-partecipa').show();
      $('.main-page').animate({
        scrollTop: $(".content-gioco-partecipa-dettaglio").offset().top
      }, 500);
      $('.gioco-partecipa-open').hide();
      $('.featured-image-gioco-partecipa').hide();

      USER.saveLocalUser(resp.user);
      USER.showProfileWidget();

      //setto il timeout del gioco; al termine del timeout mostro il riepilogo
      setTimeout(function () {
        $(".timer-gioco-quiz-container").hide();
        $('.box-container-gioco-quiz').hide();
        $('.box-container-riepilogo').show();
        // distruggo il timer del gioco quiz
        clearInterval(window.timer_gioco_quiz);
        //mostro il numero di risposte corrette
        $('#riepilogo-info-gioco-quiz').append("<span class='content-gioco-punti'>. Ops è scaduto il tempo. Hai risposto correttamente a " + window.risp_esatte_gioco_quiz + " domande.</span>");
      }, (durata_gioco + 3) * 1000);

      //inizializzo la variabile che mostra a video il tempo residuo
      window.timeout_gioco_quiz = durata_gioco;
      $(".timer-gioco-quiz-span").html(window.timeout_gioco_quiz);
      $(".timer-gioco-quiz-container").show();

      window.timer_gioco_quiz = setInterval(function () {
        $(".timer-gioco-quiz-span").html(window.timeout_gioco_quiz);
        if (window.timeout_gioco_quiz > 0) {
          window.timeout_gioco_quiz--;
        }
      }, 1000);

      // inizializzo la variabile delle risposte esatte
      window.risp_esatte_gioco_quiz = 0;

    } else if (resp.status == 1) {
      alertError("Hai già giocato!");
    } else if (resp.status == -1) {
      $("img#rds-header-users-icon").trigger('click');
    } else if (resp.status == -3) {
      alertError(resp.message);
    }
  }, function () {
    hideWaitingLoader();
    alertError("Si e' verificato un errore, prova a giocate piu' tardi");
  });

}

function chiudiGiocoQuiz() {

  $('.gioco-partecipa-open').show();
  $('.featured-image-gioco-partecipa').show();
  $('.content-gioco-partecipa').hide();
  $('.main-page').animate({
    scrollTop: $("#rds-section-main").offset().top
  }, 1000);

}

function rispondiGiocoQuiz(elem, gioco_id, id_domanda, id_risposta, j) {

  // controllo se si è già risposto alla domanda (ossia se l'attributo 'risposta-id' è presente )
  if (!$("#singola_domanda_" + j + "_gioco_quiz").attr("risposta-id")) {

    // setto a quale domanda ho risposto attualmente
    $("#rds-domande-gioco-quiz-posizione").val(j);

    // chiamata al backend per l'inserimento della risposta
    showWaitingLoader();
    API.post("community/rispondiGiocoQuiz", {
      gioco_id: gioco_id,
      id_domanda: id_domanda,
      id_risposta: id_risposta
    }, function (resp) {
      hideWaitingLoader();
      if (resp.status == 0) {
        // se la risposta è corretta (data-id = 1) altrimenti (data-id = 0)
        if ($(elem).attr("data-id") == "1") {
          $("#feedback-risposta-" + id_risposta).html("<div class='spunta-ok-gioco-quiz'></div>");
          $("#rds-domande-gioco-quiz-avanti").show();
          $("#singola_domanda_" + j + "_gioco_quiz").attr("risposta-id", id_risposta);
          window.risp_esatte_gioco_quiz += 1;
        } else {
          $("#feedback-risposta-" + id_risposta).html("<div class='spunta-ko-gioco-quiz'></div>");
          $("#rds-domande-gioco-quiz-avanti").show();
          $("#singola_domanda_" + j + "_gioco_quiz").attr("risposta-id", id_risposta);
        }
      } else if (resp.status == 1) {
        alertError("Risposta già inserita");
      }
    }, function () {
      hideWaitingLoader();
      alertError("Si e' verificato un errore, prova a giocate piu' tardi");
    });

  }

}

function avantiGiocoQuiz(max_domande) {

  var actual_index = parseInt($("#rds-domande-gioco-quiz-posizione").val());
  var next = actual_index + 1;

  if (next < max_domande) {
    $("#singola_domanda_" + actual_index + "_gioco_quiz").hide();
    $("#singola_domanda_" + next + "_gioco_quiz").show();
    $("#rds-domande-gioco-quiz-avanti").hide();
  } else {
    $('.box-container-gioco-quiz').hide();
    $('.box-container-riepilogo').show();

    $('#riepilogo-info-gioco-quiz').append("<span class='content-gioco-punti'>. Hai risposto correttamente a " + window.risp_esatte_gioco_quiz + " domande su " + max_domande + " </span>");

    //distruggo il timeout del giocoquiz
    clearInterval(window.timer_gioco_quiz);

    $('.main-page').animate({
      scrollTop: $("#rds-section-main").offset().top
    }, 500);
  }

}

/******************************* GIOCO UGC ************************************/

function partecipaUGC() {

  // controllo l'eventuale assenza di campi obbligatori
  var utente = USER.getLocalUser();

  if (checkPopupMandatoryFields(utente, partecipaUGC, [])) {
    return;
  }

  // sezione relativa alle spunte privacy e regolamento
  if (!window.accettazione_gioco_depositato) {
    // se l'utente non risulta loggato
    if (!USER.getLocalUser()) {
      $("img#rds-header-users-icon").trigger('click');
      return;
    }
    if (isSmartphone()) {
      $(".rds-modal-popup-box").css("width", "100%");
      $(".rds-modal-popup-box").css("height", "100%");
      $(".rds-modal-popup-box").css("margin-top", "140px");
    } else {
      $(".rds-modal-popup-box").css("width", "335px");
      $(".rds-modal-popup-box").css("height", "auto");
    }
    window.clickOkGiocoDepositato = function () {
      var check_regolamento = $('input[name=checkbox-regolamento-gioco-depositato]:checked').val() == 1 ? 1 : 0;
      var check_privacy = $('input[name=checkbox-liberatoria-gioco-depositato]:checked').val() == 1 ? 1 : 0;
      if (check_regolamento == 1 && check_privacy == 1) {
        RDSMODALPOPUP.close();
        window.accettazione_gioco_depositato = true;
        partecipaUGC();
      } else {
        alertError("Leggi e accetta entrambi i documenti per proseguire!");
      }
    };
    $("#rds-popup-content").html(window.templates["confirm-gioco-depositato"]);

    $("#anchor-regolamento").prop("href", window.url_regolamento);
    $("#anchor-liberatoria").prop("href", window.url_liberatoria);

    RDSMODALPOPUP.open();
    return;
  }

  // G.A @ 29/07/2019 - sezione relativa alle spunte privacy e regolamento (gioco depositato al ministero custom)
  if (!window.accettazione_gioco_depositato_custom) {
    // se l'utente non risulta loggato
    if (!USER.getLocalUser()) {
      $("img#rds-header-users-icon").trigger('click');
      return;
    }
    if (isSmartphone()) {
      $(".rds-modal-popup-box").css("width", "100%");
      $(".rds-modal-popup-box").css("height", "100%");
      $(".rds-modal-popup-box").css("margin-top", "140px");
    } else {
      $(".rds-modal-popup-box").css("width", "335px");
      $(".rds-modal-popup-box").css("height", "auto");
    }
    window.clickOkGiocoDepositatoCustom = function () {
      var check_regolamento = $('input[name=checkbox-regolamento-gioco-depositato-custom]:checked').val() == 1 ? 1 : 0;

      if (accettazione_privacy_custom == "0") {
        var check_privacy = 1;
      } else {
        var check_privacy = $('input[name=checkbox-liberatoria-gioco-depositato-custom]:checked').val() == 1 ? 1 : 0;
      }

      if (check_regolamento == 1 && check_privacy == 1) {
        RDSMODALPOPUP.close();
        window.accettazione_gioco_depositato_custom = true;
        partecipaUGC();
      } else {
        alertError("Leggi e accetta i campi obbligatori prima di proseguire!");
      }
    };
    $("#rds-popup-content").html(window.templates["confirm-gioco-depositato-custom"]);
    $("#html_gioco_depositato_custom").html(window.html_gioco_depositato_custom);
    RDSMODALPOPUP.open();
    return;
  }

  // continuo col il partecipa
  showWaitingLoader();
  USER.checkUser(function (user) {
    hideWaitingLoader();
    $('.content-gioco-partecipa').show();
    $('.main-page').animate({
      scrollTop: $(".content-gioco-partecipa-dettaglio").offset().top
    }, 500);
    $('.gioco-partecipa-open').hide();
    $('.featured-image-gioco-partecipa').hide();
  }, function () {
    hideWaitingLoader();
    //faccio aprire la finestra di login
    $("img#rds-header-users-icon").trigger('click');
  });
}

// Upload del contenuto video
$(document).on('submit', '#rds-form-gioco-ugc', function (e) {

  e.preventDefault();

  // creo la form data per l'invio
  var formData = new FormData($("form#rds-form-gioco-ugc")[0]);

  showWaitingLoader();
  API.postFormDataForVideo("community/uploadGiocoUgc", formData, function (resp) {

    hideWaitingLoader();
    if (resp.status == 0) {
      $('.box-container-ugc').hide();
      $('.box-container-riepilogo').show();
      $('.main-page').animate({
        scrollTop: $("#rds-section-main").offset().top
      }, 500);

      alert("Contenuto inserito correttamente!");

      USER.saveLocalUser(resp.user);
      USER.showProfileWidget();

      // ricarico la pagina per visualizzare subito l'immagine
      reloadNavigation();

    } else if (resp.status == -1) {
      alertError("La sessione è scaduta, per continuare devi loggarti di nuovo");
      USER.logoutNoConfirm();
    } else {
      alertError("Errore durante l'invio del contenuto");
    }

  }, function () {
    hideWaitingLoader();
    alertError("Errore durante l'invio del contenuto");
  });

});

function chiudiUGC() {
  $('.gioco-partecipa-open').show();
  $('.featured-image-gioco-partecipa').show();
  $('.content-gioco-partecipa').hide();
  $('.main-page').animate({
    scrollTop: $("#rds-section-main").offset().top
  }, 500);
}

function avantiUGC() {

  if ($('#dettaglio-gioco-ugc-file').val() == "") {
    alertError("Seleziona un file prima di proseguire");
    return;
  }

  if ($('#dettaglio-gioco-ugc-liberatoria-obligatoria').val() == "1" && $('#dettaglio-gioco-ugc-file-liberatoria').val() == "") {
    alertError("Seleziona la liberatoria prima di proseguire");
    return;
  }

  $("#rds-form-gioco-ugc").submit();
}

/****************************** GIOCO ISTANT WIN ******************************/
function partecipaGiocoIstantWin(post_id) {

  // controllo l'eventuale assenza di campi obbligatori
  var utente = USER.getLocalUser();

  if (checkPopupMandatoryFields(utente, partecipaGiocoIstantWin, [post_id])) {
    return;
  }

  // sezione relativa alle spunte privacy e regolamento
  if (!window.accettazione_gioco_depositato) {
    // se l'utente non risulta loggato
    if (!USER.getLocalUser()) {
      $("img#rds-header-users-icon").trigger('click');
      return;
    }
    if (isSmartphone()) {
      $(".rds-modal-popup-box").css("width", "100%");
      $(".rds-modal-popup-box").css("height", "100%");
      $(".rds-modal-popup-box").css("margin-top", "140px");
    } else {
      $(".rds-modal-popup-box").css("width", "335px");
      $(".rds-modal-popup-box").css("height", "auto");
    }
    window.clickOkGiocoDepositato = function () {
      var check_regolamento = $('input[name=checkbox-regolamento-gioco-depositato]:checked').val() == 1 ? 1 : 0;
      var check_privacy = $('input[name=checkbox-liberatoria-gioco-depositato]:checked').val() == 1 ? 1 : 0;
      if (check_regolamento == 1 && check_privacy == 1) {
        RDSMODALPOPUP.close();
        window.accettazione_gioco_depositato = true;
        partecipaGiocoIstantWin(post_id);
      } else {
        alertError("Leggi e accetta entrambi i documenti per proseguire!");
      }
    };
    $("#rds-popup-content").html(window.templates["confirm-gioco-depositato"]);

    $("#anchor-regolamento").prop("href", window.url_regolamento);
    $("#anchor-liberatoria").prop("href", window.url_liberatoria);

    RDSMODALPOPUP.open();
    return;
  }

  // G.A @ 29/07/2019 - sezione relativa alle spunte privacy e regolamento (gioco depositato al ministero custom)
  if (!window.accettazione_gioco_depositato_custom) {
    // se l'utente non risulta loggato
    if (!USER.getLocalUser()) {
      $("img#rds-header-users-icon").trigger('click');
      return;
    }
    if (isSmartphone()) {
      $(".rds-modal-popup-box").css("width", "100%");
      $(".rds-modal-popup-box").css("height", "100%");
      $(".rds-modal-popup-box").css("margin-top", "140px");
    } else {
      $(".rds-modal-popup-box").css("width", "335px");
      $(".rds-modal-popup-box").css("height", "auto");
    }
    window.clickOkGiocoDepositatoCustom = function () {
      var check_regolamento = $('input[name=checkbox-regolamento-gioco-depositato-custom]:checked').val() == 1 ? 1 : 0;

      if (accettazione_privacy_custom == "0") {
        var check_privacy = 1;
      } else {
        var check_privacy = $('input[name=checkbox-liberatoria-gioco-depositato-custom]:checked').val() == 1 ? 1 : 0;
      }

      if (check_regolamento == 1 && check_privacy == 1) {
        RDSMODALPOPUP.close();
        window.accettazione_gioco_depositato_custom = true;
        partecipaGiocoIstantWin(post_id);
      } else {
        alertError("Leggi e accetta i campi obbligatori prima di proseguire!");
      }
    };
    $("#rds-popup-content").html(window.templates["confirm-gioco-depositato-custom"]);
    $("#html_gioco_depositato_custom").html(window.html_gioco_depositato_custom);
    RDSMODALPOPUP.open();
    return;
  }

  // continuo col il partecipa
  showWaitingLoader();
  var pv = $("#rds-gioco-instan-win-pv").val();
  API.post("community/partecipaGioco/" + post_id, {post_id: post_id, pv: pv}, function (resp) {
    hideWaitingLoader();
    if (resp.status == 0) {

      if (resp.message == "WIN") {
        $('#rds-instant-win-result-text').html("Complimenti! Hai vinto");
      } else {
        $('#rds-instant-win-result-text').html("Ci dispiace! Non hai vinto ");
      }

      $('.content-gioco-partecipa').show();
      $('.main-page').animate({
        scrollTop: jQuery(".content-gioco-partecipa-dettaglio").offset().top
      }, 500);
      $('.gioco-partecipa-open').hide();
      $('.featured-image-gioco-partecipa').hide();
      USER.saveLocalUser(resp.user);
      USER.showProfileWidget();
    } else if (resp.status == 1) {
      alertError("Hai già giocato!");
    } else if (resp.status == -1) {
      $("img#rds-header-users-icon").trigger('click');
    } else if (resp.status == -3) {
      alertError(resp.message);
    }
  }, function () {
    hideWaitingLoader();
    alertError("Si e' verificato un errore, prova a giocate piu' tardi");
  });
}

function chiudiGiocoIstantWin() {
  $('.gioco-partecipa-open').show();
  $('.featured-image-gioco-partecipa').show();
  $('.content-gioco-partecipa').hide();
  $('.main-page').animate({
    scrollTop: jQuery("#rds-section-main").offset().top
  }, 500);
}

/******************************* GIOCO VOTA ITEM ******************************/

function votaGiocoVotaItem(post_id, ugc_id) {

  // controllo l'eventuale assenza di campi obbligatori
  var utente = USER.getLocalUser();

  if (checkPopupMandatoryFields(utente, votaGiocoVotaItem, [post_id, ugc_id])) {
    return;
  }

  // sezione relativa alle spunte privacy e regolamento NON CANCELLARE!
  /*
  if(!window.accettazione_gioco_depositato){
// se l'utente non risulta loggato
if(!USER.getLocalUser()){
    $("img#rds-header-users-icon").trigger('click');
    return;
}
if(isSmartphone()){
    $(".rds-modal-popup-box").css("width", "100%");
    $(".rds-modal-popup-box").css("height", "100%");
          $(".rds-modal-popup-box").css("margin-top", "140px");
} else{
    $(".rds-modal-popup-box").css("width", "335px");
    $(".rds-modal-popup-box").css("height", "auto");
}
window.clickOkGiocoDepositato = function () {
    var check_regolamento = $('input[name=checkbox-regolamento-gioco-depositato]:checked').val() == 1 ? 1 : 0;
    var check_privacy = $('input[name=checkbox-liberatoria-gioco-depositato]:checked').val() == 1 ? 1 : 0;
    if (check_regolamento == 1 && check_privacy == 1) {
  RDSMODALPOPUP.close();
  window.accettazione_gioco_depositato = true;
  votaGiocoVotaItem(post_id, ugc_id);
    } else {
  alertError("Leggi e accetta entrambi i documenti per proseguire!");
    }
};
$("#rds-popup-content").html(window.templates["confirm-gioco-depositato"]);

$("#anchor-regolamento").prop("href", window.url_regolamento);
$("#anchor-liberatoria").prop("href", window.url_liberatoria);

RDSMODALPOPUP.open();
return;
  }
  */

  // continuo col il partecipa
  showWaitingLoader();
  API.post("community/partecipaGioco/" + post_id, {post_id: post_id, ugc_id: ugc_id}, function (resp) {
    hideWaitingLoader();
    if (resp.status == 0) {
      alert("Il tuo voto e' stato inserito correttamente");
      reloadNavigation();
      // ricalcolo il punteggio
      USER.saveLocalUser(resp.user);
      USER.showProfileWidget();
    } else if (resp.status == 1) {
      alertError("Hai già giocato!");
    } else if (resp.status == -1) {
      $("img#rds-header-users-icon").trigger('click');
    } else if (resp.status == -3) {
      alertError(resp.message);
    }
  }, function () {
    hideWaitingLoader();
    alertError("Si e' verificato un errore, prova a giocate piu' tardi");
  });

}

function partecipaGiocoCustom(post_id) {
  console.log(window.template_gioco);
}

function condividi(url, title) {
  FB.ui({
    method: 'feed',
    name: title,
    link: url,
    picture: url,
    caption: 'RDS - 100% Grandi Successi',
    //description: "Vinci con RDS un'esperienza unica durante il derby Roma-Lazio o il match Roma-Juventus!",
  }, function (response) {
    console.log(response);
  });
}

/* Use the close button to close the modal */
$(document).on("click", ".modal-wrapper-video, .close-button-video", function () {
  hideModalVideo();
});

/* Allows the user to click the background area of the modal to hide it, without affecting any content inside the modal */
$(document).on("click", ".modal-wrapper-video", function () {
  /* Checks that the target is the outer wrapper, not the inner content of the modal */
  if (e.target != this)
    return;
  hideModalVideo();
});

function hideModalVideo() {
  $("#contenitore-modal-wrapper-video-vota-item").removeClass("modal-wrapper-video");
  $(".modal-wrapper-video").css('opacity', '0');
  setTimeout(function () {
    $(".modal-wrapper-video").css('z-index', '-1000');
    $("div#container-video").html('');
  }, 100);
}

function showModalVideo(src, width, height, tipologia) {
  if (tipologia == "video") {
    $("#contenitore-modal-wrapper-video-vota-item").addClass("modal-wrapper-video");
    $(".modal-wrapper-video").css('opacity', '1');
    setTimeout(function () {
      $(".modal-wrapper-video").css('z-index', '1000');
      $("div#container-video").html('<iframe style="width: ' + width + '; height: ' + height + ';" src="' + src + '" frameborder="0" allowfullscreen scrolling="no" ></iframe>');
    }, 100);
  }
}


/******************************* GIOCO MUSIC ENGINE ************************************/

function mostraDomandeGiocoMusicEngine() {
  $("#rds-trueview-container").show();
};

function partecipaGiocoMusicEngine(post_id) {

  // controllo l'eventuale assenza di campi obbligatori
  var utente = USER.getLocalUser();

  if (checkPopupMandatoryFields(utente, partecipaGiocoMusicEngine, [post_id])) {
    return;
  }

  // sezione relativa alle spunte privacy e regolamento
  if (!window.accettazione_gioco_depositato) {
    // se l'utente non risulta loggato
    if (!USER.getLocalUser()) {
      $("img#rds-header-users-icon").trigger('click');
      return;
    }
    if (isSmartphone()) {
      $(".rds-modal-popup-box").css("width", "100%");
      $(".rds-modal-popup-box").css("height", "100%");
    } else {
      $(".rds-modal-popup-box").css("width", "335px");
      $(".rds-modal-popup-box").css("height", "auto");
    }
    window.clickOkGiocoDepositato = function () {
      var check_regolamento = $('input[name=checkbox-regolamento-gioco-depositato]:checked').val() == 1 ? 1 : 0;
      var check_privacy = $('input[name=checkbox-liberatoria-gioco-depositato]:checked').val() == 1 ? 1 : 0;
      if (check_regolamento == 1 && check_privacy == 1) {
        RDSMODALPOPUP.close();
        window.accettazione_gioco_depositato = true;
        partecipaGiocoMusicEngine(post_id);
      } else {
        alertError("Leggi e accetta entrambi i documenti per proseguire!");
      }
    };
    $("#rds-popup-content").html(window.templates["confirm-gioco-depositato"]);

    $("#anchor-regolamento").prop("href", window.url_regolamento);
    $("#anchor-liberatoria").prop("href", window.url_liberatoria);

    RDSMODALPOPUP.open();
    return;
  }

  // G.A @ 29/07/2019 - sezione relativa alle spunte privacy e regolamento (gioco depositato al ministero custom)
  if (!window.accettazione_gioco_depositato_custom) {
    // se l'utente non risulta loggato
    if (!USER.getLocalUser()) {
      $("img#rds-header-users-icon").trigger('click');
      return;
    }
    if (isSmartphone()) {
      $(".rds-modal-popup-box").css("width", "100%");
      $(".rds-modal-popup-box").css("height", "100%");
      $(".rds-modal-popup-box").css("margin-top", "140px");
    } else {
      $(".rds-modal-popup-box").css("width", "335px");
      $(".rds-modal-popup-box").css("height", "auto");
    }
    window.clickOkGiocoDepositatoCustom = function () {
      var check_regolamento = $('input[name=checkbox-regolamento-gioco-depositato-custom]:checked').val() == 1 ? 1 : 0;

      if (accettazione_privacy_custom == "0") {
        var check_privacy = 1;
      } else {
        var check_privacy = $('input[name=checkbox-liberatoria-gioco-depositato-custom]:checked').val() == 1 ? 1 : 0;
      }

      if (check_regolamento == 1 && check_privacy == 1) {
        RDSMODALPOPUP.close();
        window.accettazione_gioco_depositato_custom = true;
        partecipaGiocoMusicEngine(post_id);
      } else {
        alertError("Leggi e accetta i campi obbligatori prima di proseguire!");
      }
    };
    $("#rds-popup-content").html(window.templates["confirm-gioco-depositato-custom"]);
    $("#html_gioco_depositato_custom").html(window.html_gioco_depositato_custom);
    RDSMODALPOPUP.open();
    return;
  }

  // continuo col il partecipa
  showWaitingLoader();
  API.post("community/partecipaGioco/" + post_id, {post_id: post_id}, function (resp) {
    hideWaitingLoader();
    if (resp.status == 0) {

      $('.content-gioco-partecipa').show();
      $('.main-page').animate({
        scrollTop: $(".content-gioco-partecipa-dettaglio").offset().top
      }, 500);
      $('.gioco-partecipa-open').hide();
      $('.featured-image-gioco-partecipa').hide();

      USER.saveLocalUser(resp.user);
      USER.showProfileWidget();

    } else if (resp.status == 1) {
      alertError("Hai già giocato!");
    } else if (resp.status == -1) {
      $("img#rds-header-users-icon").trigger('click');
    } else if (resp.status == -3) {
      alertError(resp.message);
    }
  }, function () {
    hideWaitingLoader();
    alertError("Si e' verificato un errore, prova a giocate piu' tardi");
  });

}

function chiudiGiocoMusicEngine() {

  $('.gioco-partecipa-open').show();
  $('.featured-image-gioco-partecipa').show();
  $('.content-gioco-partecipa').hide();
  $('.main-page').animate({
    scrollTop: $("#rds-section-main").offset().top
  }, 1000);

}

function rispondiGiocoMusicEngine(elem, gioco_id, id_domanda, id_risposta, j) {

  // controllo se si è già risposto alla domanda (ossia se l'attributo 'risposta-id' è presente )
  if (!$("#singola_domanda_" + j + "_gioco_quiz").attr("risposta-id")) {

    // setto a quale domanda ho risposto attualmente
    $("#rds-domande-gioco-quiz-posizione").val(j);

    // chiamata al backend per l'inserimento della risposta
    showWaitingLoader();
    API.post("community/rispondiGiocoQuiz", {
      gioco_id: gioco_id,
      id_domanda: id_domanda,
      id_risposta: id_risposta
    }, function (resp) {
      hideWaitingLoader();
      if (resp.status == 0) {
        $("#id-risposta-" + id_risposta).css("font-weight", "600").css("color", "rgba(179, 45, 36, 1)");
        $("#rds-domande-gioco-quiz-avanti").show();
        $("#singola_domanda_" + j + "_gioco_quiz").attr("risposta-id", id_risposta);
      } else if (resp.status == 1) {
        alertError("Risposta già inserita");
      }
    }, function () {
      hideWaitingLoader();
      alertError("Si e' verificato un errore, prova a giocate piu' tardi");
    });

  }

}

function avantiGiocoMusicEngine(max_domande, post_id) {

  var actual_index = parseInt($("#rds-domande-gioco-quiz-posizione").val());
  var next = actual_index + 1;

  if (next < max_domande) {
    $("#singola_domanda_" + actual_index + "_gioco_quiz").hide();
    $("#singola_domanda_" + next + "_gioco_quiz").show();
    $("#rds-domande-gioco-quiz-avanti").hide();
  } else {
    $('.box-container-gioco-quiz').hide();
    $('.box-container-riepilogo').show();

    // controllo il profilo associato
    check_profilo_music_engine(post_id);

    $('.main-page').animate({
      scrollTop: $("#rds-section-main").offset().top
    }, 500);
  }

}

function check_profilo_music_engine(post_id) {
  showWaitingLoader();
  API.post("community/profilo_music_engine", {post_id: post_id}, function (resp) {
    hideWaitingLoader();
    var html = "<span class='content-gioco-punti'>.</span>\n\
		    <br>\n\
		    <p style=\"font-size: 18px; margin: 20px;\">Il tuo profilo è: <br><br><span style=\"color: rgba(179, 45, 36, 1); font-weight: 600\">" + resp.profilo_utente.title + "</span> <br><br>" + resp.profilo_utente.description + "</p>\n\
		    <p style=\"font-size: 18px; margin-bottom: 20px;\">La canzone associata al tuo profilo è: <br><br><span style=\"color: rgba(179, 45, 36, 1); font-weight: 600\">" + resp.profilo_utente_song.titolo + "</span></p>\n\
		    <p style=\"font-size: 18px; \"><img style=\"width: 250px; height: 250px;\" src='" + resp.profilo_utente_song.src_img + "'></p>\n\
		    <p style=\"font-size: 18px; margin-bottom: 20px;\"><audio controls><source src=\"" + resp.profilo_utente_song.audio + "\" type=\"audio/mpeg\">Your browser does not support the audio element.</audio></p>";

    $('#riepilogo-info-gioco-quiz').append(html);
  }, function () {
    hideWaitingLoader();
    alertError("Si e' verificato un errore, prova a giocate piu' tardi");
  });
}

function loadStoricoPunti(data) {

  showWaitingLoader();
  USER.checkUser(function (user) {

    API.get("community/get_storico_punti", {}, function (resp) {
      hideWaitingLoader();
      if (resp.status == 0) {

        var tHeader = $('<tr>');
        var tHeader1 = $('<td class="font-weight-700" >').html("Evento");
        var tHeader2 = $('<td class="font-weight-700 text-aligh-center">').html("Punti");
        var tHeader3 = $('<td class="font-weight-700 text-aligh-center">').html("Data");
        tHeader.append(tHeader1);
        tHeader.append(tHeader2);
        tHeader.append(tHeader3);

        $('#rds-storico-punti-table').append(tHeader);

        $.each(resp.storico, function (i) {
          var tRow = $('<tr>');
          var tdescription = $('<td class="font-weight-300 text-align-left">').html(resp.storico[i].descrizione);
          var tpoints = $('<td class="font-weight-700 text-aligh-center">').html(resp.storico[i].points);
          var tdataEsecuzione = $('<td class="font-weight-300 text-align-center">').html(resp.storico[i].data_esecuzione);
          tRow.append(tdescription);
          tRow.append(tpoints);
          tRow.append(tdataEsecuzione);
          $('#rds-storico-punti-table').append(tRow);
        });

        //inserisco i punti relativi all'iscrizione alla community
        var tRow = $('<tr>');
        var tdescription = $('<td class="font-weight-300 text-align-left">').html("Iscrizione alla community");
        var tpoints = $('<td class="font-weight-700 text-aligh-center">').html("250");
        var tdataEsecuzione = $('<td class="font-weight-300 text-align-center">').html("-");
        tRow.append(tdescription);
        tRow.append(tpoints);
        tRow.append(tdataEsecuzione);
        $('#rds-storico-punti-table').append(tRow);

      }
    }, function () {
      hideWaitingLoader();
      alertError("Si e' verificato un errore");
    });

  }, function () {
    // se non sono loggato vado in homepage
    hideWaitingLoader();
    addNavigation("/");
  });

}

//
//
// function puntiCondivisione(post_id,post_title){
//
//     API.post("community/assegnaPuntiCondivisioneGioco", {post_id: post_id, post_title: post_title}, function (resp) {
//                 console.log('Punti per condivisione social');
//             }, function () {
//                 console.log('Error api');
//     });
//
// }
//
// function richiesta_cancellazione() {
//     var answer = confirm("Hai richiesto di cancellare definitivamente il tuo profilo. Sei sicuro?");
//     if (answer) {
// 	API.get("community/richiedi_cancellazione_utente", {}, function (resp) {
// 	    console.log('richiesta cancellazione utente');
//
// 	    API.get("community/logout", {}, function (resp) {
//
// 		RDSGOOGLEANALYTICS.logout();
// 		USER.logoutNoConfirm();
//
//             });
//
// 	}, function () {
// 	    console.log('errore richiesta cancellazione utente');
// 	});
//     }
// }
//
//
// function checkPopupMandatoryFields(utente, callback, args) {
//
//     if (utente != null && (utente.nome == "" || !utente.nome || utente.cognome == "" || !utente.cognome || utente.telefono == "" || !utente.telefono || utente.email == "" || !utente.email || utente.luogo == "" || !utente.luogo || utente.nascita == "" || !utente.nascita)) {
//         alert("Prima di proseguire con il gioco, completa il tuo profilo con i dati mancanti");
//         addNavigation("/profile", function () {
//             selezionaTabcommunity('#rds-profile-page-tab-child-2', 3);
//         });
//         // window.global_callback = {callback};
//         return true;
//     }
//
//     return false;
//
// }

window.popupPrimaDiGiocare = function (extrainfo) {
  // tracciamenti caffeina
  const utm_source = Utils.findGetParameter('utm_source');
  const utm_medium = Utils.findGetParameter('utm_medium');
  const utm_campaign = Utils.findGetParameter('utm_campaign');
  const utm_content = Utils.findGetParameter('utm_content');
  const isReload = Utils.findGetParameter('reload') == 1;

  if (!Utils.getCookie("utm_source")) {
    if (!isReload) {
      let data = {
        "utm_campaign": utm_campaign,
        "utm_content": utm_content,
        "utm_medium": utm_medium,
        "utm_source": utm_source,
        url: location.href
      };
      eventBus.emit(EVENTS.PARTECIPA_GIOCO_SEMPLICE, data);
    }
    utm_source ? Utils.setCookie("utm_source", utm_source, 0.04) : false;
    utm_source ? Utils.setCookie("utm_medium", utm_medium, 0.04) : false;
    utm_source ? Utils.setCookie("utm_campaign", utm_campaign, 0.04) : false;
    utm_source ? Utils.setCookie("utm_content", utm_content, 0.04) : false;
    Utils.setCookie("redirect_url", location.href, 0.04);
  }

  // se l'utente non risulta loggato

  if (!user.getLocalUser()) {
    user.openLoginPopupGame(window.slug_game);
    return;
  }

  /*
  * Gioco la dichiaro in maniera statica, poi quando verrà creato l'evento credimi sarà valorizzata dinamicamente
  */

  let gioco = "credimi";
  if (gioco == "gio") {
    Utils.confirmCustom("Per proseguire in questa sezione, completa il tuo profilo inserendo i dati mancanti!",
      "",
      () => {
        //addNavigation("/profilo");
        Utils.confirmCampiExtra("",
          "",
          () => {
            $("#gioco_campi_extra").show();
            if ($("#piva").val() != "")
              saveAdditionalExtraField();
          },
          () => {
            $(".popup-messaggio-main").hide();
            return
          },
          "SALVA",
          "ANNULLA");
      },
      () => {
        $(".popup-messaggio-main").hide();
        return
      },
      "PROSEGUI",
      "ANNULLA");
  } else {
    // controllo se ci sono tutti i campi obbligatori dell'utente
    if (checkPopupMandatoryFields(user.getLocalUser())) {
      return;
    }
  }

  if (!window.accettazione_gioco_depositato_custom) {

    window.clickOkGiocoDepositatoCustom = function () {

      var check_regolamento = $('input[name=checkbox-regolamento-gioco-depositato-custom]:checked').val() == 1 ? 1 : 0;

      if (accettazione_privacy_custom == "0") {
        var check_privacy = 1;
      } else {
        var check_privacy = $('input[name=checkbox-liberatoria-gioco-depositato-custom]:checked').val() == 1 ? 1 : 0;
      }

      if (check_regolamento == 1 && check_privacy == 1) {
        window.accettazione_gioco_depositato_custom = true;
        $('.popup-prima-di-giocare').remove();
        partecipaGioco(extrainfo);
      } else {
        $("#mandatory-fields-gioco-depositato-custom").show();
      }

    };

    var tmp = window.templates["gioco-depositato-custom"];
    $("#rds-main").append(tmp.replace("{{html_gioco_depositato_custom}}", window.html_gioco_depositato_custom));

  } else {
    partecipaGioco(extrainfo);
  }

}


function partecipaGioco(extrainfo) {


  // eventBus.emit(EVENTS.GIOCO_SEMPLICE_END, {url: location.href});

  console.log("tipologia: " + window.tipologia_gioco + ", post_id: " + window.gioco_id);

  Utils.showWaitingLoader();

  switch (window.tipologia_gioco) {

    case 'gioco_semplice':

      API.post("community/partecipaGioco/" + window.gioco_id, {post_id: window.gioco_id}, function (resp) {

        Utils.hideWaitingLoader();

        if (resp.status == 0) {
          hai_gia_partecipato("gioco_semplice", {punti: resp.punti}, resp.alertFineGioco, 0);
          user.saveLocalUser(resp.user);
        } else if (resp.status == 1) {
          Utils.alertError("Hai già giocato!");
        } else if (resp.status == -1) {
          user.checkUserLogged();
        } else if (resp.status == -3) {
          Utils.alertError(resp.message);
        }

      }, function () {
        Utils.hideWaitingLoader();
        Utils.alertError("Si è verificato un errore, prova a giocare più tardi");
      });

      break;

    case 'ugc':
    case 'vota_item':

      // se si tratta di un voto

      if (extrainfo) {

        API.post("community/partecipaGioco/" + window.gioco_id, {
          post_id: window.gioco_id,
          ugc_id: extrainfo
        }, function (resp) {

          Utils.hideWaitingLoader();

          if (resp.status == 0) {
            hai_gia_partecipato(window.tipologia_gioco, {punti: resp.punti}, null, 0);
            user.saveLocalUser(resp.user);
          } else if (resp.status == 1) {
            Utils.alertError("Hai già votato!");
          } else if (resp.status == -1) {
            user.checkUserLogged();
          } else if (resp.status == -3) {
            Utils.alertError(resp.message);
          }

        }, function () {
          Utils.hideWaitingLoader();
          Utils.alertError("Si è verificato un errore, prova a giocare più tardi");
        });

      } else {

        Utils.hideWaitingLoader();

        $("#rds-main").append(window.templates["carica_file_ugc"]);

        // setto il corretto 'accept' per il campo input se l'utente non ha ancora giocato
        if (window.tipo_contenuto_ugc == "FOTO") {
          $('#dettaglio-gioco-ugc-file').attr("accept", "image/x-png,image/jpeg");
        } else {
          $('#dettaglio-gioco-ugc-file').attr("accept", "video/mp4,video/x-m4v,video/*,audio/mp3,audio/*");
        }

        // controllo se la liberatoria è obbligatoria o meno
        if (window.liberatoria_obbligatoria_ugc == 1) {
          $('#dettaglio-ugc-box-liberatoria').css('display', 'inline-block');
        } else {
          $('#dettaglio-ugc-box-liberatoria').css('display', 'none');
        }

      }

      break;

    case 'true_view':

      if (extrainfo) {

        var scelta;

        if (extrainfo == "-1") {
          scelta = "-1"
        } else {
          scelta = window.scelta_trueview;
        }

        API.post("community/partecipaGioco/" + window.gioco_id, {
          post_id: window.gioco_id,
          scelta: scelta
        }, function (resp) {

          Utils.hideWaitingLoader();

          if (resp.status == 0) {
            hai_gia_partecipato("true_view", {punti: resp.punti}, null, 0);
            user.saveLocalUser(resp.user);
          } else if (resp.status == 1) {
            Utils.alertError("Hai già giocato!");
          } else if (resp.status == -1) {
            user.checkUserLogged();
          } else if (resp.status == -3) {
            Utils.alertError(resp.message);
          }

        }, function () {
          Utils.hideWaitingLoader();
          Utils.alertError("Si è verificato un errore, prova a giocare più tardi");
        });

      } else {

        API.post("community/partecipaGioco/" + window.gioco_id, {
          post_id: window.gioco_id,
          scelta: "0"
        }, function (resp) {
        }, function () {
        });

        Utils.hideWaitingLoader();

        $("#rds-main").append(window.templates["istruzioni_trueview"].replace("{{url_video_hls_trueview}}", window.url_video_hls_trueview));

      }

      break;
    case 'quiz':
    case 'music_engine':

      API.post("community/partecipaGioco/" + window.gioco_id, {post_id: window.gioco_id}, function (resp) {
      }, function () {
      });

      Utils.hideWaitingLoader();

      $("#gioco-container-cta .cta-button").remove();
      $("#gioco-come-partecipare").remove();
      $("#gioco-music-engine-quesiti-container").show();
      $("#singola_domanda_0_gioco_quiz").show();
      $('html, body').animate({
        scrollTop: ($("#gioco-music-engine-quesiti-container").offset().top) - 130
      }, 500);

      break;
    case 'gioco_select':
      $("#gioco-container-cta .cta-button").remove();
      $("#gioco-come-partecipare").remove();
      $("#gioco-music-engine-quesiti-container").show();
      $("#singola_domanda_0_gioco_quiz").show();
      Utils.hideWaitingLoader();
      $('html, body').animate({
        scrollTop: ($("#gioco-music-engine-quesiti-container").offset().top) - 130
      }, 500);
      break;
    case 'instant_win':

      API.post("community/partecipaGioco/" + window.gioco_id, {
        post_id: window.gioco_id,
        pv: window.percentuale_di_vincita
      }, function (resp) {
        Utils.hideWaitingLoader();


        if (resp.status == 1) {
          Utils.alertError("Hai già giocato!");

        } else if (resp.status == -1) {
          user.checkUserLogged();

        } else if (resp.status == -3) {
          Utils.alertError(resp.message);

        } else {

          $("#gioco-container-cta .cta-button").remove();
          $("#gioco-come-partecipare").remove();
          $("#gioco_instant_win").show();

          $('html, body').animate({
            scrollTop: ($("#gioco_instant_win").offset().top) - 130
          }, 500);
          setTimeout(function () {
            $("#card_rotante").removeClass("rotating");
            $(".img_rotante").css("visibility", "hidden");
            $(".popup-conferma-button").show();
            if (resp.message == "WIN") {
              console.log("Win");

              $("#card_rotante").addClass("win");
              $("#card_rotante").append("<span class='testo_card sofia_font'>HAI VINTO!</span>");

            } else {
              console.log("Lost");

              $("#card_rotante").addClass("lost");

              $("#card_rotante").append("<span class='testo_card sofia_font'>HAI PERSO!</span>");
            }


          }, 4000)
        }


      });
      break;
    case 'gioco_codice':
      Utils.codicePerGiocare('',rispondiGiocoCodice);
      Utils.hideWaitingLoader();
      break;
    case 'gioco_custom':
    default:
      Utils.hideWaitingLoader();
  }
  onPartecipa();
}

function checkPopupMandatoryFields(utente) {
  if (utente != null && (utente.nome == "" || !utente.nome || utente.cognome == "" || !utente.cognome || utente.telefono == "" || !utente.telefono ||
    utente.email == "" || !utente.email /*|| utente.luogo == "" || !utente.luogo || utente.nascita == "" || !utente.nascita*/)) {
    // Utils.alertError("Prima di proseguire con il gioco, completa il tuo profilo con i dati mancanti");
    Utils.confirmCustom("Prima di proseguire con il gioco, completa il tuo profilo con i dati mancanti",
      "",
      () => {
        //addNavigation("/profilo");
        Utils.additionalParameter("", "", () => {
            $("#gioco_campi_extra").show();
            if ($("#telefono").val() != "")
              saveAdditionalField(utente.userid);
          },
          () => {
            $(".popup-messaggio-main").hide();
          },
          "SALVA",
          "ANNULLA");
      },
      () => {
        $(".popup-messaggio-main").hide();
      },
      "PROSEGUI",
      "ANNULLA");

    return true;
  }

  return false;

}


window.mostraAltriItemsGioco = function (elem) {

  var x = $(elem).data("start");
  x = x + 6;
  $('#dettaglio_gioco-items-gioco .single-box-preferiti').slice(0, x).slideDown();
  $(elem).data("start", x);

}

window.apriGiocoVideo = function (url_video_hls) {

  var titolo = $(".title_gioco").text();
  var durata = $(".gioco_durata").text();

  let apri_player_video = new Promise(function (resolve, reject) {

    try {
      openPlayerBottom("gioco-video");
      resolve();
    } catch (e) {
      reject();
    }

  });

  apri_player_video.then(
    function (value) {

      const podcast_object = {
        immagine: "",
        titolo: titolo,
        categoria: "",
        catSlug: "",
        giorno: durata,
        id: "",
        type: 'videoPodcast',
        videoSrc: url_video_hls,
        doNotTrackEvent: true
      };

      eventBus.emit(EVENTS.PLAYER_PODCAST_NEW_SONG, podcast_object);
      playerPodcast.setSources([url_video_hls]);
      playerPodcast.play();

      openPlayerBottom("podcast-video");
      fillExtendedPlayer("podcast-video");

    },
    function (error) {
      console.log("errore player");
    }
  );

}

$(document).on('change', '#dettaglio-gioco-ugc-file', (e) => {
  $("#dettaglio-gioco-ugc-file-readonly").val(e.target.files[0].name);
});

$(document).on('change', '#dettaglio-gioco-ugc-liberatoria', (e) => {
  $("#dettaglio-gioco-ugc-liberatoria-readonly").val(e.target.files[0].name);
});

// Upload del contenuto video

window.uploadGiocoUgc = function () {

  $(".fieldset-ugc-file").removeClass("fieldset-error");
  $(".fieldset-ugc-liberatoria").removeClass("fieldset-error");

  if ($("#dettaglio-gioco-ugc-file").val() == "") {
    $(".fieldset-ugc-file").addClass("fieldset-error");
  }

  if (window.liberatoria_obbligatoria_ugc == "1" && $("#dettaglio-gioco-ugc-liberatoria").val() == "") {
    $(".fieldset-ugc-liberatoria").addClass("fieldset-error");
  }

  var formData = new FormData();

  formData.append('dettaglio-gioco-ugc-gioco-id', window.gioco_id);
  formData.append('dettaglio-gioco-ugc-liberatoria-obligatoria', window.liberatoria_obbligatoria_ugc);

  var myFileInputFile = document.getElementById("dettaglio-gioco-ugc-file");
  formData.append('dettaglio-gioco-ugc-file', myFileInputFile.files[0], myFileInputFile.files[0].name);

  if (window.liberatoria_obbligatoria_ugc == "1") {
    var myFileInputLiberatoria = document.getElementById("dettaglio-gioco-ugc-liberatoria");
    formData.append('dettaglio-gioco-ugc-file-liberatoria', myFileInputLiberatoria.files[0], myFileInputLiberatoria.files[0].name);
  }

  Utils.showWaitingLoader();

  API.postFormData("community/uploadGiocoUgc", formData, function (resp) {

    Utils.hideWaitingLoader();

    if (resp.status == 0) {

      $('#popup-gioco-carica-file-ugc').remove();

      Utils.alertMessage("Contenuto inserito correttamente!");

      user.saveLocalUser(resp.user)

      // ricarico la pagina per visualizzare subito l'immagine

      replaceNavigation(window.slug_game);

    } else if (resp.status == -1) {
      Utils.alertError("La sessione è scaduta, per continuare devi loggarti di nuovo");
      user.logoutNoConfirm();
      replaceNavigation(window.slug_game);
    } else {
      Utils.alertError("Errore durante l'invio del contenuto");
    }

  }, function () {
    Utils.hideWaitingLoader();
    Utils.alertError("Errore durante l'invio del contenuto");
  }, 300000);

};

window.visualizzaVideoTrueview = function (url_video_hls) {

  $('#popup-gioco-trueview').remove();

  var titolo = $(".title_gioco").text();
  var durata = $(".gioco_durata").text();

  let apri_player_video = new Promise(function (resolve, reject) {

    try {
      openPlayerBottom("gioco-video");
      resolve();
    } catch (e) {
      reject();
    }

  });

  apri_player_video.then(
    function (value) {

      var events_ended = playerPodcast.on("ended", function () {

        $(".show_for_trueview").hide();
        $("#close_bottom_player").click();
        $("#gioco-trueview-quesito").fadeIn();
        $("#gioco-come-partecipare").remove();
        $("#gioco-container-cta .cta-button").hide();

        playerPodcast.off(events_ended);
        $('html, body').animate({
          scrollTop: ($("#gioco-trueview-quesito").offset().top) - 130
        }, 500);

      });

      const podcast_object = {
        immagine: "",
        titolo: titolo,
        categoria: "",
        catSlug: "",
        giorno: durata,
        id: "",
        type: 'videoPodcast',
        videoSrc: url_video_hls,
        doNotTrackEvent: true
      };

      eventBus.emit(EVENTS.PLAYER_PODCAST_NEW_SONG, podcast_object);
      playerPodcast.setSources([url_video_hls]);
      playerPodcast.play();

      openPlayerBottom("podcast-video");
      fillExtendedPlayer("podcast-video");

      $(".hide_for_trueview").css('visibility', 'hidden');

      $(".show_for_trueview").show();

    },
    function (error) {
      console.log("errore player");
    }
  );

}

window.selezionaDomandaTrueview = function (elem, scelta) {

  $(".contenitore-domanda-trueview").removeClass("trueview-selected");
  $(elem).addClass("trueview-selected");
  window.scelta_trueview = scelta;

}

// esci per sempre dal gioco
$(document).on('click', '.esci_dal_gioco', (e) => {

  playerPodcast.pause();

  Utils.confirmCustom("Sei sicuro di voler uscire dal gioco?",
    "Uscendo dal gioco non ti sarà più possibile partecipare.",
    () => {
      $(".popup-messaggio-main").hide();
      if ($("#player_bottom").is(":visible")) {
        playerPodcast.play();
      }
    },
    () => {
      popupPrimaDiGiocare("-1")
    },
    "CONTINUA",
    "ESCI DAL GIOCO");

});

function getTemplateRisposteGiocoSelect(post_id, json_risposte) {
  let answers = '';
  let i = 1;
  if (json_risposte.find(r => r.gm_immagine) == null && json_risposte.find(r => r.gm_immagine) == null) {
    for (const risposta of json_risposte) {
      let singleAnswer = `
      <div class="font_18 opacity_8 margin-bottom-20" id="game-${post_id}" onclick="rispondiGiocoSemplice(this,${post_id}, 'id-risposta-${i}')">
        <div class="contenitore-domanda-trueview flex post-h-main post-h-mobile">
          <div class="bold color_blue font_24 font_18_mobile count-q">
            <span>${i}</span><span class="hide_mobile">.</span>
          </div>
          <div id='id-risposta-${i}' class="singola-risposta-music-engine option-text font_16_mobile">
            ${risposta.gm_risposta}
          </div>
          <div class="sub" style="font-weight: 300; font-size: 17px;">${risposta.gm_sottotitolo}</div>
        </div>
      </div>`;
      i++;
      answers += singleAnswer;
    }
  } else if (json_risposte.find(r => r.gm_video) != null) {
    answers = '<div class="flex select-image-container">';
    json_risposte = json_risposte.map(i => {
      return {
        ...i,
        gm_immagine: i.gm_immagine.replace('http://localhost/wplocal', 'https://media.rds.it/web')
        // gm_video:i.gm_video.replace('http://localhost/wplocal', 'https://media.rds.it/web')
      }
    });
    for (const risposta of json_risposte) {
      let singleAnswer = `
      <div class="font_18 margin-bottom-20 select-image-single" id="game-${post_id}-${i}" style="width:100%; position:relative;">
<!--      <div class="font_18 margin-bottom-20 select-image-single" id="game-${post_id}" onclick="rispondiGiocoSemplice(this,${post_id}, 'id-risposta-${i}')" style="width:100%; position:relative;">-->
        <div class="contenitore-domanda-trueview-select flex " id="container-domanda-${i}" >
<!--        <div style="width:100%; display: flex">-->
<!--          <img style="width:100%" src="${risposta.gm_immagine}" />-->
<!--        </div>-->
          <div id='id-risposta-${i}' class="riposta-image-select sofia_font" style="border: none;">
            <b>${risposta.gm_risposta}</b>
          </div>
          <div class="sub">${risposta.gm_sottotitolo}</div>
          <div class="video-select" id='id-video-${i}' onclick="riproduciVideo('${risposta.gm_video}','${risposta.gm_risposta}','${risposta.gm_sottotitolo}')" >
            <div class="play-image">
           </div>
            <img src="${risposta.gm_immagine}"  alt="Immagine" style="max-height: 300px"/>
           </div>
          <div class="select-image-button-select" style="border: none" onclick="votaItem(this,${post_id},${i})">VOTA</div>
        </div>
      </div>`;
      i++;
      answers += singleAnswer;
    }
    answers += '</div>'
  } else {
    answers = '<div class="flex select-image-container">';
    json_risposte = json_risposte.map(i => {
      return {
        ...i,
        gm_immagine: i.gm_immagine.replace('http://localhost/wplocal', 'https://media.rds.it/web')
        // gm_video:i.gm_video.replace('http://localhost/wplocal', 'https://media.rds.it/web')
      }
    });
    for (const risposta of json_risposte) {
      let singleAnswer = `
      <div class="font_18 margin-bottom-20 select-image-single" id="game-${post_id}" onclick="rispondiGiocoSemplice(this,${post_id}, 'id-risposta-${i}')" style="width:100%; position:relative;">
        <div class="contenitore-domanda-trueview flex post-h-main" >
        <div style="width:100%; display: flex">
          <img style="width:100%" src="${risposta.gm_immagine}" />
        </div>
          <div id='id-risposta-${i}' class="riposta-image sofia_font">
            ${risposta.gm_risposta}
          </div>
          <div id='id-video-${i}' class="riposta-image sofia_font">
            ${risposta.gm_video}
          </div>
          <div class="select-image-button">Scegli</div>
        </div>
      </div>`;
      i++;
      answers += singleAnswer;
    }
    answers += '</div>'
  }
  return answers;
}

function getTemplateRisposteGiocoQuiz(post_id, domanda_id, json_risposte) {
  let answers = '';
  let i = 0;
  for (const risposta of json_risposte) {
    let singleAnswer = `
      <div data-id='${risposta.profile}' onclick='rispondiGiocoMusicEngine(this,${post_id},${domanda_id},${risposta.id},${i})'
        class="font_18 opacity_8 margin-bottom-20">
        <div class="contenitore-domanda-trueview flex post-h-main post-h-mobile">
          <div class="bold color_blue font_24 font_18_mobile count-q">
            <span>${i + 1}</span><span class="hide_mobile">.</span>
          </div>
          <div id='id-risposta-${risposta.id}' class="singola-risposta-music-engine option-text font_16_mobile">
            ${risposta.risposta}
          </div>
        </div>
      </div>`;
    i++;
    answers += singleAnswer;
  }
  return answers;
}


function json_risposte(data, tipologia) {
  let struttura_domande = "";

  for (var j = 0; j < data.content.num_domande; j++) {
    const post_id = data.content.post_id;
    const quiz = data.content.gioco_quiz[j];
    const quizId = quiz.id || j;
    let json_risposte = JSON.parse(quiz.json_risposte);
    let answers;
    let title = 'rispondi alle domande';
    if (tipologia == "gioco_select") {
      json_risposte = quiz.options.risposte;
      if (quiz.options.options.gsmo_partecipazione_multipla) {
        maxPartecipazioni = quiz.options.options.gsmo_numero_massimo_di_partecipazioni;
      }
      answers = getTemplateRisposteGiocoSelect(post_id, json_risposte);
      title = 'fai la tua scelta e partecipa';
    } else {
      answers = getTemplateRisposteGiocoQuiz(post_id, quiz.domanda_id, json_risposte);
    }
    $('#gioco-music-engine-quesiti-container .in-evidenza-title span').text(title);
    struttura_domande += `
      <div id='singola_domanda_${j}_gioco_quiz' class='singola_domanda_gioco_quiz singola_domanda_${quizId}_gioco_quiz'>
        <div id="" class="p-main sofia_font dark_font">
          <div class="font_24 font_20_mobile bold title-ask">
            ${quiz.domanda}
          </div>
          ${answers}
        </div>
      </div>
    `;
  }

  $("#rds-domande-gioco-quiz").html(struttura_domande);
  const durataGioco = data.content.gioco_quiz[0].durata_gioco_quiz || false;
  const circleCountdown = document.getElementById("circle_countdown");
  if (durataGioco) {

    onPartecipa = () => {
      const cssVar = '--durata-secondi-gioco';
      const cssVar2 = '--durata-gioco';
      const root = document.documentElement;
      root.style.setProperty(cssVar2, durataGioco);
      root.style.setProperty(cssVar, durataGioco + "s");
      $(".c-timer__count").text(durataGioco + "s");
      let timeleft = parseInt(durataGioco);
      let secondi = 0;
      downloadTimer = setInterval(function () {
        timeleft -= 1;
        secondi += 1;
        $("#circle_countdown").attr("data-sec", secondi);
        $(".c-timer__count").text(timeleft + "s");

        if (timeleft <= 15) {
          circleCountdown.style.stroke = "#EF3824"
        } else if (timeleft <= 30) {
          circleCountdown.style.stroke = "#FECB32"
        } else {
          circleCountdown.style.stroke = "#0F4F9B"
        }

        if (timeleft == 0) {
          if (document.getElementById("circle_countdown")) {
            document.getElementById("circle_countdown").style.animationPlayState = "paused";
          }
          clearInterval(downloadTimer);
          visualizzaRispostaMusicaEngine(data.content.post_id);
          $(document).animate({
            scrollTop: 0
          }, 500);
          //   rispondiQuizTempo(id_gioco);
        }

      }, 1000)
      $('#countdownbar').show();
    };

  }

  $("#rds-domande-gioco-quiz-posizione").val(0);

}

window.votaItem = function (elem, post_id, index) {
  const allItem = document.getElementsByClassName('contenitore-domanda-trueview-select');
  for (let i = 0; i < allItem.length; i++) {
    allItem[i].classList.remove('selected');
    allItem[i].style.backgroundColor = 'white';
    allItem[i].style.boxShadow = 'none';
  }
  const selectedItem = document.getElementById("container-domanda-" + index);
  selectedItem.classList.add('selected');
  selectedItem.style.backgroundColor = '#90bac7';
  selectedItem.style.boxShadow = '10px 10px 10px 0px rgba(0, 0, 0, 0.25)';
  console.log('Hai votato lui', index);
  const idRisposta = 'id-risposta-' + index;
  var popup_confirm = `
      <div class='popup-errore-main'>
            <div id='popup-errore-box' class='popup-login-box' style='transform: translate(-50%, -50%)'>
                <div class='x-delete elimina-account-close'><img
                    src='https://media.rds.it/web/web-site-brandnew/svg/icon-close-black.svg'></div>
                <div class='popup-errore-inside'>
                    <span class='register-title sofia_font font_36 font_34_tablet font_28_mobile'>Confermi il tuo voto?</span>
<!--                    <span class='register-title sofia_font font_24 font_24_tablet font_24_mobile'>Sicurə di voler dare la preferenza?</span> <br>-->
                    <span class='sofia_font font_22 font_22_tablet font_22_mobile'>Puoi esprimere massimo una preferenza al giorno.</span>
                    <div style="display:flex; justify-content: space-around; color: white; text-align: center; font-size: 30px; padding : 20px">
                        <div class="reject-popup" style="background-color: #ef3824;min-width: 150px"> NO</div>
                        <div class="confirm-popup" style="background-color: #18307a;min-width: 150px"> SI</div>
                    </div>
                </div>
            </div>
            <div class='background-overlay-grey' style='display: block'></div>
        </div>
      `;
  $("#rds-main").append(popup_confirm);
  const rispondiListener = function () {
    $(".popup-errore-main").remove();
    rispondiGiocoSemplice(elem, gioco_id, idRisposta);
  };
  document.getElementsByClassName("confirm-popup")[0].addEventListener("click", rispondiListener);
  $(document).on("click", ".reject-popup", function () {
    selectedItem.classList.remove('selected');
    selectedItem.style.backgroundColor = 'white';
    selectedItem.style.boxShadow = 'none';
    document.getElementsByClassName("confirm-popup")[0].removeEventListener('click', rispondiListener);
    $(".popup-errore-main").remove();
  });
  $(document).on("click", ".x-delete", function () {
    selectedItem.classList.remove('selected');
    selectedItem.style.backgroundColor = 'white';
    selectedItem.style.boxShadow = 'none';
    document.getElementsByClassName("confirm-popup")[0].removeEventListener('click', rispondiListener);
    $(".popup-errore-main").remove();
  });

}

window.rispondiGiocoMusicEngine = function (elem, gioco_id, id_domanda, id_risposta, j) {


  $(".singola-risposta-music-engine").removeClass("trueview-selected");

  // setto a quale domanda ho risposto attualmente
  $("#rds-domande-gioco-quiz-posizione").val(j);

  // chiamata al backend per l'inserimento della risposta
  Utils.showWaitingLoader();

  API.post("community/rispondiGiocoQuiz", {
    gioco_id: gioco_id,
    id_domanda: id_domanda,
    id_risposta: id_risposta
  }, function (resp) {
    Utils.hideWaitingLoader();
    if (resp.status == 0) {
      $("#id-risposta-" + id_risposta).addClass("trueview-selected");
      $("#rds-domande-gioco-quiz-avanti").show();
      $("#singola_domanda_" + j + "_gioco_quiz").attr("risposta-id", id_risposta);
    } else if (resp.status == 1) {
      Utils.alertError("Risposta già inserita");
    }
  }, function () {
    Utils.hideWaitingLoader();
    Utils.alertError("Si è verificato un errore, prova a giocare più tardi");
  });

}

window.riproduciVideo = function (src, title, subtitle, image) {
  if(!src){
    return
  }
  // $("#bottom_player_categoria").text('');
  // $("#bottom_player_titolo").text('');
  // src = 'https://video.rds.it/web/feb794786f2442495aac8b8f809c50944fc486f6ad4b6600aab5681a6ad746a7/720p/feb794786f2442495aac8b8f809c50944fc486f6ad4b6600aab5681a6ad746a7.mp4';
  const podcast_object = {
    immagine: image,
    titolo: title||'',
    categoria: subtitle||'',
    catSlug: 'category',
    giorno: '',
    id: 1,
    type: 'videoPodcast',
    videoSrc: src
  };

  if(podcast_object.titolo && podcast_object.categoria){
    $("#bottom_player_categoria").text(podcast_object["categoria"]);
    $("#bottom_player_titolo").text(podcast_object["titolo"]);
  }

  const source = {
    type: 'video/mp4',
    src: src
  }

  eventBus.emit(EVENTS.PLAYER_PODCAST_NEW_SONG, podcast_object);
  window.playerPodcast.setSources([source]);
  window.playerPodcast.ima = [];
  window.playerPodcast.play();
  $("#bottom_player_titolo").text(podcast_object["titolo"]);
  openPlayerBottom('podcast-video');
  fillExtendedPlayer('podcast-video');

  // window.videoPlayer.waitPreroll=false;
  // window.videoPlayer.ima = null;
  // // const source = {src:src,type:'video/*'};
  // window.videoPlayer.setSources([src]);
  // window.videoPlayer.play();
}

window.rispondiGiocoSemplice = function (elem, gioco_id, idRisposta) {

  $(".singola-risposta-music-engine").removeClass("trueview-selected");


  // chiamata al backend per l'inserimento della risposta
  Utils.showWaitingLoader();


  function genericError() {
    Utils.hideWaitingLoader();
    Utils.alertError("Si è verificato un errore, prova a giocare più tardi");
  }

  jQuery(`#${idRisposta}`).addClass("trueview-selected");
  const risposta = jQuery(`#${idRisposta}`).text().trim();

  API.post("community/partecipaGioco/" + gioco_id, {post_id: gioco_id, risposta}, function (resp) {
    if (resp.status == 0) {
      Utils.hideWaitingLoader();
      let afterGameText = `Grazie per aver partecipato`;
      if (maxPartecipazioni > 1) {
        const numberGiocate = resp.cnt_giocate;
        if (numberGiocate >= maxPartecipazioni) {
          afterGameText = `Grazie per aver partecipato!<br />Hai terminato le preferenze a disposizione per oggi.`;
        } else {
          afterGameText = `Grazie per aver partecipato! <br /> Hai ancora a disposizione ${maxPartecipazioni - numberGiocate} preferenze per oggi.`;
          $('#gioco-container-hai-gia-giocato .cta-button button').text('Partecipa di nuovo');
          $('#gioco-container-hai-gia-giocato .cta-button').append(`
            <div id="gioco-container-hai-gia-giocato-overlay"></div>
          `);
          $('#gioco-container-hai-gia-giocato-overlay').one('click', (e) => {
            e.preventDefault();
            $('#gioco-container-hai-gia-giocato .cta-button button').text('ALTRI GIOCHI');
            $('#gioco-container-hai-gia-giocato-overlay').remove();
            replaceNavigation(location.href)
          });
        }
      }
      $('.title-after-game').html(afterGameText);
      $("#gioco-music-engine-quesiti-container").fadeOut();
      $('html, body, .main-page').animate({
        scrollTop: 0
      }, 500);
      $("#gioco-container-cta").fadeOut();
      $("#gioco-container-hai-gia-giocato").fadeIn();
    } else {
      genericError()
    }
  }, genericError);
}


window.avantiGiocoMusicEngine = function (max_domande, post_id) {

  var actual_index = parseInt($("#rds-domande-gioco-quiz-posizione").val());
  var next = actual_index + 1;

  if (next < max_domande) {

    $("#singola_domanda_" + actual_index + "_gioco_quiz").hide();
    $("#singola_domanda_" + next + "_gioco_quiz").show();
    $("#rds-domande-gioco-quiz-avanti").hide();

  } else {

    $('.box-container-gioco-quiz').hide();
    $('.box-container-riepilogo').show();

    // controllo il profilo associato
    visualizzaRispostaMusicaEngine(post_id);

    // $('.main-page').animate({
    //     scrollTop: $("#rds-section-main").offset().top
    // }, 500);
  }

}

window.visualizzaRispostaMusicaEngine = function (post_id) {

  Utils.showWaitingLoader();

  API.post("community/profilo_music_engine", {post_id: post_id}, function (resp) {

    Utils.hideWaitingLoader();

    console.log(resp);

    var profilo_utente = resp.profilo_utente;
    var song = resp.profilo_utente_song;
    if (song) {
      let apri_player_music = new Promise(function (resolve, reject) {

        try {
          openPlayerBottom("music-engine");
          resolve();
        } catch (e) {
          reject();
        }

      });

      apri_player_music.then(
        function (value) {

          const podcast_object = {
            immagine: song.src_img,
            titolo: song.titolo,
            categoria: song.artista,
            catSlug: "",
            giorno: "",
            id: "",
            type: 'song',
            videoSrc: "",
            doNotTrackEvent: true
          };

          eventBus.emit(EVENTS.PLAYER_PODCAST_NEW_SONG, podcast_object);
          playerPodcast.setSource(song.audio);

          openPlayerBottom("music-engine");

          fillMusicEngine(profilo_utente.description, profilo_utente.title, song.titolo, song.artista, song.src_img);

          $(".hide_for_music_engine").css('visibility', 'hidden');

          $(".show_for_music_engine").show();

        },
        function (error) {
          console.log("errore player");
        }
      );
    }


    hai_gia_partecipato(window.tipologia_gioco, {
      punti: resp.punti,
      music_engine_profilo: resp.profilo,
      music_engine_descrizione: resp.descrizione,
      music_engine_canzone: resp.canzone,
      music_engine_immagine: resp.immagine
    }, null, 0);

  });

}

window.closePopupCustom = function () {
  $(".popup-messaggio-main").hide();
}


function saveAdditionalField(userid) {

  var formData = new FormData();

  let tel = $("#telefono").val();

  formData.append('telefono', tel);
  formData.append('user_id', userid);
  Utils.showWaitingLoader();

  API.postFormData("community/setMandatoryField", formData, function (resp) {
    Utils.hideWaitingLoader();

    if (resp.status == 1) {

      Utils.alertMessageGiochi("Salvataggio avvenuto con successo!", popupPrimaDiGiocare);
      user.saveLocalUser(resp.user)
      // ricarico la pagina per visualizzare subito l'immagine
      let newUrl = location.href;
      if (location.search) {
        newUrl += '&';
      } else {
        newUrl += '?';
      }
      newUrl += 'reload=1';
      replaceNavigation(newUrl);
    } else {
      Utils.alertError("Errore durante il salvataggio");
    }
  }, function () {
    Utils.hideWaitingLoader();
    Utils.alertError("Errore durante il salvataggio");
  }, 300000);
}

function saveAdditionalExtraField(userid) {

  let formData = new FormData();
  let rapLegale = $("#mailRapLegale").val().trim();
  let nomeImpresa = $("#nomeImpresa").val().trim();
  let piva = $("#piva").val().trim();

  formData.append('rapLegale', rapLegale);
  formData.append('nomeImpresa', nomeImpresa);
  formData.append('piva', piva);

  Utils.showWaitingLoader();

  API.postFormData("site/saveExtraFieldGame", formData, function (resp) {
    Utils.hideWaitingLoader();

    if (resp.status == 1) {
      Utils.alertMessageGiochi("Salvataggio avvenuto con successo!", popupPrimaDiGiocare);
      /*user.saveLocalUser(resp.user)
      // ricarico la pagina per visualizzare subito l'immagine
      replaceNavigation(window.slug_game);*/
    } else {
      Utils.alertError("Errore durante il salvataggio");
    }
  }, function () {
    Utils.hideWaitingLoader();
    Utils.alertError("Errore durante il salvataggio");
  }, 300000);
}


function fillMusicEngine(descrizione, titolo, titolo_song, artista_song, cover) {

  $(".hide_for_trueview").css('visibility', 'visible');
  $(".hide_for_music_engine").css('visibility', 'visible');
  $(".show_for_trueview").hide();

  $(".extended_block").hide();
  $(".extended_block").removeClass("active");

  $("#titolo_profilo_utente").text(titolo);
  $("#descrizione_profilo_utente").text(descrizione);
  $("#song_profilo_cover").attr("src", cover);
  $("#titolo_song_utente").text(titolo_song);
  $("#artista_song_utente").text(artista_song);

  $("#playing_music_engine_extended").show();

  openExtPlayer();

}

function rispondiGiocoCodice(post_id,codice){
  var utente = user.getLocalUser();

  if (checkPopupMandatoryFields(utente, rispondiGiocoCodice, [post_id])) {
    return;
  }
  if(codice){
    eventBus.emit(EVENTS.GIOCO_CUSTOM_CODICE_STEP2);
  }
  Utils.showWaitingLoader();
  API.post("community/partecipaGioco/" + post_id, {post_id: post_id,codice:codice}, function (resp) {
    Utils.hideWaitingLoader();
    if (resp.status == 1) {
      hai_gia_partecipato('gioco_codice',{punti:0}, null, 0);
      // USER.saveLocalUser(resp.user);
      // USER.showProfileWidget();
    } else if (resp.status == 0) {
      alertError("Hai già giocato!");
    } else if (resp.status == -1) {
      $("img#rds-header-users-icon").trigger('click');
    } else if (resp.status == -3) {
      alertError(resp.message);
    }
  }, function () {
    Utils.hideWaitingLoader();
    alertError("Si e' verificato un errore, prova a giocate piu' tardi");
  });
}

